import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  es: {
    app_title: "GP by Rawen's",
    app_subtitle: "Gestión de Órdenes y Tareas",
    login_title: "GP by Rawen's",
    login_subtitle: "Gestión de Órdenes y Tareas",
    email: "Correo electrónico",
    email_or_username: "Correo o Usuario",
    username: "Usuario",
    password: "Contraseña",
    name: "Nombre",
    enter: "Entrar",
    logout: "Salir",
    leave_blank_to_keep: "Dejar vacío para mantener actual",

    tab_dashboard: "Tablero",
    tab_insights: "Tablero Universal",
    tab_orders: "Órdenes",
    tab_tasks: "Tareas",
    tab_calendar: "Calendario",
    tab_employees: "Empleados",
    tab_order_history: "Historial",

    // Sprint O1 — Production board (item-centric)
    tab_production: "Producción",
    production_title: "Cola de Producción",
    production_subtitle: "Cada producto, su estado, responsable y bloqueadores en una sola vista",
    production_empty: "No hay productos que coincidan con los filtros",
    production_filter_blocker: "Bloqueador",
    production_filter_status: "Estado",
    production_filter_employee: "Responsable",
    production_filter_method: "Método",
    production_filter_all: "Todos",
    production_filter_reset: "Limpiar filtros",
    production_open_order: "Abrir orden",
    production_assignee_unassigned: "Sin responsable",
    production_blocker_missing_art: "Falta arte",
    production_blocker_missing_payment: "Falta pago",
    production_blocker_missing_material: "Falta material",
    production_blocker_missing_approval: "Falta aprobación",
    production_blocker_art: "Arte aprobado",
    production_blocker_payment: "Pago recibido",
    production_blocker_material: "Material recibido",
    production_blocker_approval: "Aprobación del cliente",
    production_status_pending: "Pendiente",
    production_status_design: "Diseño",
    production_status_ready_for_production: "Listo para producir",
    production_status_in_production: "En producción",
    production_status_ready_for_delivery: "Listo para entrega",
    production_status_delivered: "Entregado",
    production_count: "{n} productos en cola",

    // Dashboard
    dashboard_title: "Tablero de Producción",
    dashboard_subtitle: "Métricas en tiempo real · órdenes ordenadas por fecha de entrega más cercana",
    kpi_overdue: "Órdenes Atrasadas",
    kpi_today: "Para Hoy",
    kpi_week: "Esta Semana",
    kpi_total: "Total Abiertas",
    kpi_open_orders: "Órdenes Abiertas",
    kpi_deliveries_today: "Entregas Hoy",
    kpi_deliveries_week: "Entregas Esta Semana",
    kpi_total_pending: "Pendiente por Cobrar",
    kpi_total_collected: "Total Cobrado",
    kpi_section_operational: "Operativos",
    kpi_section_financial: "Financieros",

    // Orders
    new_order: "Nueva orden",
    edit_order: "Editar orden",
    invoice_number: "Número de Factura",
    company_name: "Nombre de Empresa",
    customer: "Cliente",
    customer_phone: "Teléfono del Cliente",
    product: "Producto",
    delivery_date: "Fecha de Entrega",
    days_remaining_label: "Días Restantes",
    notes: "Notas",
    status: "Estado",
    total_amount: "Monto Total",
    deposit_received: "Depósito Recibido",
    pending_balance: "Balance Pendiente",
    download_pdf: "Descargar PDF",
    production_order: "Orden de Producción",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    no_orders: "Aún no hay órdenes. Crea la primera.",

    // Order statuses (5 fixed)
    order_status_design: "Diseño",
    order_status_waiting_approval: "Esperando Aprobación",
    order_status_production: "Producción",
    order_status_ready: "Listo para Entrega",
    order_status_delivered: "Entregado",

    // Countdown
    overdue_by: (n) => `Atrasado por ${n} ${n === 1 ? "día" : "días"}`,
    due_today: "Para Hoy",
    due_tomorrow: "Para Mañana",
    days_remaining: (n) => `Faltan ${n} ${n === 1 ? "día" : "días"}`,

    // Tasks
    new_task: "Nueva tarea",
    edit_task: "Editar tarea",
    task_name: "Nombre de tarea",
    assigned_to: "Asignada a",
    due_date: "Fecha límite",
    mark_completed: "Marcar Completada",
    completed: "Completada",
    no_tasks: "No hay tareas asignadas.",
    filter_employee: "Empleado",
    filter_status: "Estado",
    filter_due: "Vencimiento",
    all: "Todos",
    unassigned: "Sin asignar",
    none: "Ninguna",
    pending: "Pendiente",
    today: "Hoy",
    this_week: "Esta semana",
    overdue: "Atrasadas",
    upcoming: "Próximas",
    related_order: "Orden / Empresa",
    task_status_pending: "Pendiente",
    task_status_in_progress: "En progreso",
    task_status_completed: "Completada",

    // Employees
    new_employee: "Nuevo empleado",
    edit_employee: "Editar empleado",
    role: "Puesto",
    no_employees: "Aún no hay empleados.",

    // Misc
    confirm_delete: "¿Seguro que deseas eliminar?",
    welcome: "Bienvenido",
    my_tasks: "Mis Tareas",
    orders_dashboard: "Órdenes Abiertas",
    sorted_by_delivery: "Ordenadas por proximidad de entrega",
    error_generic: "Algo salió mal. Inténtalo de nuevo.",
    admin: "Administrador",
    worker: "Empleado",
    no_filtered_tasks: "No hay tareas con esos filtros.",

    // Phase 3 — Items / Contact / Details / History / Calendar
    contact_person: "Persona de Contacto",
    items: "Productos",
    item: "Producto",
    add_item: "+ Agregar Producto",
    remove_item: "Quitar",
    product_code: "Código",
    description: "Descripción",
    quantity: "Cantidad",
    item_notes: "Notas",
    view_details: "Ver Detalles",
    order_details: "Detalles de Orden",
    customer_info: "Información del Cliente",
    financial_info: "Información Financiera",
    products_list: "Lista de Productos",
    related_tasks: "Tareas Relacionadas",
    no_related_tasks: "Sin tareas relacionadas",
    create_task_for_item: "+ Crear tarea para este producto",
    general_order_tasks: "Tareas generales de la orden",
    item_tasks_label: "Tareas del producto",
    no_item_tasks: "Aún no hay tareas para este producto",
    locked_product_hint: "Producto bloqueado (heredado del item de la orden)",
    close: "Cerrar",
    order_history: "Historial de Órdenes",
    search: "Buscar",
    search_placeholder: "Buscar por cliente, empresa, contacto, teléfono o factura...",
    search_orders_placeholder: "Buscar por empresa, cliente, factura, orden o teléfono...",
    search_tasks_placeholder: "Buscar por empresa, cliente, orden, tarea o teléfono...",
    no_history_results: "No se encontraron órdenes entregadas",
    active_orders: "Órdenes Activas",
    section_active: "Activas",
    section_history: "Entregadas",

    // Calendar
    calendar_title: "Calendario de Carga",
    calendar_subtitle: "Vista mensual de tareas por empleado · arrastra para reprogramar",
    prev_month: "Mes anterior",
    next_month: "Mes siguiente",
    today_btn: "Hoy",
    legend_overdue: "Atrasada",
    legend_unassigned: "Sin asignar",
    drop_to_reschedule: "Soltar para reprogramar",
    reschedule_success: "Tarea reprogramada",
    task_description: "Descripción de Tarea",

    // Task Details Modal
    task_details: "Detalles de Tarea",
    open_order: "Abrir Orden",
    no_order_linked: "Sin orden vinculada",

    // Invoice PDF attachment
    import_invoice_pdf: "Importar PDF de Factura",
    invoice_pdf_save_first: "Guarda la orden primero para adjuntar el PDF",
    invoice_pdf_uploaded: "PDF de factura cargado",
    invoice_pdf_deleted: "PDF eliminado",
    invoice_pdf_attached: "PDF Adjunto",
    invoice_pdf_view: "Ver PDF",
    invoice_pdf_replace: "Reemplazar PDF",
    invoice_pdf_remove: "Quitar PDF",
    invoice_pdf_invalid: "Selecciona un archivo PDF válido",
    invoice_pdf_uploading: "Subiendo PDF...",
    invoice_pdf_none: "Aún no hay PDF adjunto",
    invoice_pdf_select: "Seleccionar PDF",
    invoice_pdf_drop_hint: "Haz clic para elegir o arrastra el PDF aquí",
    invoice_pdf_uploaded_at: "Subido",

    // Task Priority
    priority: "Prioridad",
    priority_normal: "Normal",
    priority_priority: "Prioritaria",
    priority_urgent: "Urgente",

    // Task Type (additive — categorización para reportes)
    task_type: "Tipo de tarea",
    task_type_placeholder: "Selecciona un tipo",
    task_type_other_placeholder: "Describe el tipo de tarea",

    // Configuración (Sprint 1 — Configuración Financiera)
    tab_settings: "Configuración",
    settings_title: "Configuración",
    settings_subtitle: "Módulos administrativos del sistema",
    settings_financial_card_title: "Configuración Financiera",
    settings_financial_card_desc: "Administra categorías y productos con costo promedio",
    settings_product_types_card_title: "Tipos de Producto",
    settings_product_types_card_desc: "Define los tipos base que tendrán los productos del sistema",
    settings_catalogs_card_title: "Catálogos Maestros",
    settings_catalogs_card_desc: "Marcas, proveedores, tallas, colores, materiales, métodos de decoración, ubicaciones del logo y más",
    settings_card_coming_soon: "Próximamente",
    catalogs_hub_title: "Catálogos Maestros",
    catalogs_hub_subtitle: "Base reutilizable del ERP · agregá entradas en cualquier momento",
    cat_brands_title: "Marcas",
    cat_suppliers_title: "Proveedores",
    cat_item_types_title: "Tipos de Ítem",
    cat_uom_title: "Unidades de Medida",
    cat_sizes_title: "Tallas",
    cat_colors_title: "Colores",
    cat_decoration_methods_title: "Métodos de Decoración",
    cat_logo_locations_title: "Ubicaciones del Logo",
    cat_materials_title: "Materiales",
    // Smart Products (Catálogo de Productos) — V2 aditivo
    settings_smart_products_card_title: "Catálogo de Productos",
    settings_smart_products_card_desc: "Productos inteligentes que definen qué campos pide GP en cada orden",
    // Phase-1 Add Product architecture (Catalog · Custom · Service)
    add_item_picker_title: "Agregar producto a la orden",
    add_item_picker_subtitle: "Elige de dónde viene este ítem. Estas 3 opciones son la nueva arquitectura permanente de GP.",
    add_item_picker_select: "Seleccionar",
    add_item_from_catalog_title: "Ropa y Uniformes",
    add_item_from_catalog_desc: "Playeras, polos, gorras, bolsas y más — con SKU, colores y tallas listos para usar.",
    add_item_custom_catalog_title: "Productos Personalizados",
    add_item_custom_catalog_desc: "Consultá el catálogo interno de productos personalizados de GP.",
    add_item_manual_title: "Producto Manual",
    tab_finance: "Finanzas",
    fin_title: "Reportes y Contabilidad",
    fin_subtitle: "Resumen financiero de Rawen's",
    fin_period_today: "Hoy",
    fin_period_week: "Esta semana",
    fin_period_month: "Este mes",
    fin_period_year: "Este año",
    fin_period_custom: "Personalizado",
    fin_apply: "Aplicar",
    fin_loading: "Cargando datos financieros…",
    fin_empty: "Sin resultados para este periodo.",
    fin_err_server: "Error del servidor al consultar los datos financieros",
    fin_err_forbidden: "No tenés autorización para ver esta información",
    fin_kpi_invoiced: "Ventas facturadas",
    fin_kpi_collected: "Dinero cobrado",
    fin_kpi_receivables: "Pendiente por cobrar",
    fin_kpi_costs: "Costos registrados",
    fin_kpi_gross: "Ganancia bruta",
    fin_kpi_margin: "Margen bruto",
    fin_kpi_coverage: "Cobertura de costos",
    fin_estimated: "estimada",
    fin_warn_title: "Ganancia estimada",
    fin_warn_body: "algunas líneas no tienen costos registrados. La ganancia puede estar sobreestimada.",
    fin_costs_complete: "Costos completos para el periodo seleccionado.",
    fin_details: "Detalle del periodo",
    fin_invoice_count: "Facturas incluidas",
    fin_no_lines: "No hay líneas para evaluar costos en este periodo.",
    fin_vs_prev: "vs periodo anterior",
    fin_vs_yoy: "vs mismo periodo año anterior",
    fin_new: "Nuevo",
    fin_no_change: "Sin cambio",
    fin_donut_title: "Cobrado vs. Pendiente por cobrar",
    fin_donut_empty: "Sin cobros ni saldos pendientes para mostrar.",
    fin_trend_title: "Tendencia del periodo",
    fin_trend_empty: "Sin datos para graficar en este periodo.",
    fin_total: "Total",
    fin_receivables_note: "Saldo actual — sin comparación histórica",
    fin_ar_title: "Cuentas por cobrar",
    fin_ar_loading: "Cargando cuentas por cobrar…",
    fin_ar_empty: "No hay facturas pendientes de cobro.",
    fin_ar_total: "Total pendiente",
    fin_ar_not_due: "Por vencer",
    fin_ar_due_today: "Vence hoy",
    fin_ar_b_1_7: "1–7 días vencida",
    fin_ar_b_8_30: "8–30 días vencida",
    fin_ar_b_30: "Más de 30 días vencida",
    fin_ar_no_date: "Sin fecha de vencimiento",
    fin_ar_days: "días",
    fin_ar_col_number: "Invoice",
    fin_ar_col_customer: "Cliente",
    fin_ar_col_phone: "Teléfono",
    fin_ar_col_invoice_date: "Fecha invoice",
    fin_ar_col_delivery: "Entrega",
    fin_ar_col_total: "Total",
    fin_ar_col_paid: "Pagado",
    fin_ar_col_balance: "Saldo",
    fin_ar_col_status: "Estado",
    fin_ar_col_aging: "Atraso",
    fin_ar_st_unpaid: "Sin pagar",
    fin_ar_st_partial_paid: "Pago parcial",
    fin_ar_st_due_on_delivery: "Pago a la entrega",
    fin_bi_title: "Importar gastos bancarios (Bank of America)",
    fin_bi_upload: "Subir CSV del banco",
    fin_bi_loading: "Procesando…",
    fin_bi_error: "Error al procesar el archivo",
    fin_bi_imported: "Importados",
    fin_bi_skipped: "Duplicados omitidos",
    fin_bi_rejected: "Rechazados",
    fin_bi_confirm: "Confirmar y guardar",
    fin_bi_dup: "Duplicado",
    fin_bi_sum_expenses: "Gastos seleccionados",
    fin_bi_sum_refunds: "Reembolsos",
    fin_bi_sum_net: "Gasto neto",
    fin_bi_sum_excluded: "Excluidos",
    fin_bi_sum_dups: "Duplicados",
    fin_bi_sum_rows: "Movimientos",
    fin_bi_col_date: "Fecha",
    fin_bi_col_desc: "Descripción",
    fin_bi_col_amount: "Monto",
    fin_bi_col_type: "Tipo",
    fin_bi_col_category: "Categoría",
    fin_bi_col_dup: "Estado",
    fin_bi_t_gasto: "Gasto",
    fin_bi_t_reembolso_gasto: "Reembolso de gasto",
    fin_bi_t_transferencia_no_contabilizar: "Transferencia / no contabilizar",
    fin_bi_t_deposito_no_contabilizar: "Depósito / no contabilizar",
    fin_bi_c_materiales: "Materiales",
    fin_bi_c_publicidad: "Publicidad",
    fin_bi_c_software_suscripciones: "Software/Suscripciones",
    fin_bi_c_servicios: "Servicios",
    fin_bi_c_renta: "Renta",
    fin_bi_c_nomina: "Nómina",
    fin_bi_c_impuestos: "Impuestos",
    fin_bi_c_transporte: "Transporte",
    fin_bi_c_comisiones_bancarias: "Comisiones bancarias",
    fin_bi_c_sales_tax_remitido: "Sales tax remitido",
    fin_bi_c_otros: "Otros",
    fin_kpi_sales_pretax: "Ventas antes de impuestos",
    fin_kpi_tax_invoiced: "Sales tax facturado",
    fin_kpi_total_with_tax: "Total facturado con impuestos",
    fin_kpi_exempt: "Ventas exentas",
    fin_kpi_gross_pretax: "Ganancia bruta provisional (antes de imp.)",
    fin_kpi_margin_pretax: "Margen bruto provisional (antes de imp.)",
    fin_collected_note: "Incluye sales tax",
    fin_ex_tax_remitted: "Sales tax remitido",
    fin_bi_new_cat: "+ Crear nueva categoría",
    fin_bi_new_cat_title: "Nueva categoría",
    fin_bi_create: "Crear",
    fin_bi_cancel: "Cancelar",
    fin_bi_manage_cats: "Gestionar categorías",
    fin_bi_custom_cats: "Categorías personalizadas",
    fin_bi_deactivate: "Desactivar",
    fin_bi_activate: "Activar",
    fin_bt_title: "Movimientos bancarios importados",
    fin_bt_empty: "No hay movimientos bancarios importados.",
    fin_bt_type_all: "Todos los tipos",
    fin_bt_cat_all: "Todas las categorías",
    fin_bt_search: "Buscar descripción…",
    fin_bt_col_file: "Archivo",
    fin_bt_col_imported_at: "Importado el",
    fin_bt_col_imported_by: "Importado por",
    fin_bt_col_status: "Estado",
    fin_bt_status_all: "Todos los estados",
    fin_bt_status_active: "Activo",
    fin_bt_status_voided: "Anulado",
    fin_bt_batches_title: "Lotes de importación",
    fin_bt_void: "Anular lote",
    fin_bt_reactivate: "Reactivar lote",
    fin_bt_void_confirm: "¿Anular este lote? Sus movimientos quedarán marcados como anulados y no se incluirán en cálculos futuros. No se elimina ningún registro.",
    fin_bt_react_confirm: "¿Reactivar este lote? Sus movimientos volverán a estar activos.",
    fin_ex_title: "Gastos bancarios y resultado del periodo",
    fin_ex_gross: "Gastos bancarios brutos",
    fin_ex_refunds: "Reembolsos",
    fin_ex_net: "Gasto bancario neto",
    fin_ex_count: "Movimientos contabilizados",
    fin_ex_materials: "Materiales pagados",
    fin_ex_equipment: "Equipos/Maquinaria pagados",
    fin_ex_operating: "Gastos operativos",
    fin_ex_cashflow: "Flujo neto de caja",
    fin_ex_result: "Resultado operativo estimado",
    fin_ex_cashflow_note: "Flujo de caja: compara los pagos registrados en GP con las salidas bancarias clasificadas. No representa ganancia contable.",
    fin_ex_excluded_note: "Materiales y Equipos/Maquinaria participan en el flujo de caja, pero no en el resultado operativo estimado (evita duplicar costos de producción y capital financiado).",
    fin_ex_overstated: "Este resultado puede estar sobreestimado porque existen líneas de facturas sin costo registrado.",
    fin_ex_disclaimer: "Este cálculo combina ventas facturadas, costos de producción conocidos y gastos bancarios clasificados. No sustituye un estado financiero preparado por un contador.",
    fin_ex_by_category: "Gasto neto por categoría",
    fin_ex_trend: "Tendencia de gasto bancario neto",
    fin_ex_empty: "No hay movimientos bancarios en este periodo.",
    fin_dl_pdf: "Descargar PDF",
    fin_dl_xlsx: "Descargar Excel",
    fin_payment_count: "Pagos incluidos",
    fin_total_lines: "Líneas totales",
    fin_lines_with_cost: "Líneas con costo",
    fin_lines_missing_cost: "Líneas sin costo",
    fin_pending_cost_alert: "Hay {n} productos con costo pendiente. La ganancia puede estar sobreestimada.",
    fin_review_invoices: "Revisar facturas",
    inv_filter_pending_cost: "Costo pendiente",
    inv_cost_section: "Costos (solo Admin)",
    inv_cost_pending: "Costo pendiente",
    inv_cost_recorded: "Costo registrado",
    inv_cost_unit: "Costo por unidad",
    inv_cost_confirm_zero: "Confirmar costo real en $0",
    inv_cost_save: "Guardar costo",
    inv_cost_saved: "Costo guardado",
    inv_cost_save_err: "No se pudo guardar el costo",
    inv_cost_confirm_zero_hint: "Marca la casilla para confirmar un costo real de $0.",
    rc_tab_summary: "Resumen",
    rc_tab_receipts: "Recibos",
    rc_add: "Agregar recibo",
    rc_new_title: "Nuevo recibo",
    rc_edit_title: "Editar recibo",
    rc_date: "Fecha del recibo",
    rc_vendor: "Comercio / Proveedor",
    rc_amount: "Monto",
    rc_category: "Categoría",
    rc_office: "Sucursal",
    rc_office_none: "— Sin sucursal —",
    rc_file: "Archivo del recibo (JPG, PNG o PDF)",
    rc_file_replace: "Reemplazar archivo (opcional)",
    rc_current_file: "Archivo actual",
    rc_save: "GUARDAR RECIBO",
    rc_saved: "Recibo guardado",
    rc_updated: "Recibo actualizado",
    rc_deleted: "Recibo eliminado",
    rc_err: "Error al guardar el recibo",
    rc_load_err: "No se pudieron cargar los recibos",
    rc_delete_err: "No se pudo eliminar el recibo",
    rc_file_err: "No se pudo abrir el archivo",
    rc_required: "Completa los campos obligatorios (fecha, comercio, monto, categoría y archivo)",
    rc_search: "Buscar por comercio, monto o fecha…",
    rc_filters: "Filtros",
    rc_year: "Año",
    rc_month: "Mes",
    rc_all: "Todos",
    rc_view: "Ver",
    rc_download: "Descargar",
    rc_print: "Imprimir",
    rc_edit: "Editar",
    rc_delete: "Eliminar",
    rc_confirm_delete: "¿Está seguro de que desea eliminar este recibo?",
    rc_empty: "No hay recibos. Presiona «+ Agregar recibo» para guardar el primero.",
    add_item_manual_desc: "Agregá un producto o servicio puntual sin guardarlo en ningún catálogo.",
    manual_item_form_title: "Producto Manual",
    manual_item_form_subtitle: "Este item se agrega solo a este documento. No se guarda en el catálogo.",
    manual_item_description: "Descripción",
    manual_item_description_ph: "Ej: Installation Service",
    manual_item_quantity: "Cantidad",
    manual_item_price: "Precio unitario",
    manual_item_note: "Nota del producto",
    manual_item_note_ph: "Nota visible para el cliente (opcional)",
    manual_item_add: "Agregar producto",
    manual_item_required_desc: "La descripción es obligatoria",
    add_item_custom_title: "Producto Personalizado",
    add_item_custom_desc: "Flujo manual clásico: define SKU, descripción, marca, proveedor y campos específicos.",
    add_item_service_title: "Servicio",
    add_item_service_desc: "Diseño gráfico, instalación, digitalización, envío, orden urgente, consultoría.",
    // ─ Nueva arquitectura escalable (Feb 2026): dos tiers ─
    add_product_button: "Agregar producto",
    add_product_router_title: "¿De dónde viene el producto?",
    add_product_router_subtitle: "Selecciona un origen para agregar ítems a esta orden.",
    add_product_source_rawens_title: "Rawen's Inventory",
    add_product_source_rawens_desc: "Productos internos, personalizados y servicios de tu propio inventario.",
    add_product_source_purchasing_title: "Purchasing Center",
    add_product_source_purchasing_desc: "Catálogos oficiales de proveedores (SanMar, S&S, AlphaBroder, ...).",
    add_product_back: "Cambiar origen",
    // Purchasing Center — supplier picker
    purchasing_pick_supplier_title: "Elige un proveedor",
    purchasing_pick_supplier_subtitle: "Cada proveedor mantiene su propio catálogo oficial.",
    purchasing_supplier_unavailable: "No disponible aún",
    purchasing_supplier_coming_soon: "Próximamente",
    purchasing_open_catalog: "Abrir catálogo",
    // Supplier catalog search
    supplier_catalog_title: "Catálogo del proveedor",
    supplier_catalog_search_placeholder: "Buscar por SKU, estilo, marca o palabra clave...",
    supplier_catalog_filter_brand: "Marca",
    supplier_catalog_filter_category: "Categoría",
    supplier_catalog_all: "Todas",
    supplier_catalog_no_results: "Sin resultados. Prueba otras palabras clave o quita filtros.",
    supplier_catalog_results: "resultados",
    supplier_catalog_starting_from: "desde",
    supplier_catalog_colors: "colores",
    supplier_catalog_sizes: "tallas",
    supplier_catalog_open_product: "Ver producto",
    // Supplier product detail
    supplier_detail_view_on_vendor: "Ver en el sitio del proveedor",
    supplier_detail_wholesale_cost: "Costo mayorista",
    supplier_detail_msrp: "Precio sugerido (MSRP)",
    supplier_detail_pick_color: "Elige color",
    supplier_detail_pick_size: "Cantidad por talla",
    supplier_detail_your_price: "Tu precio",
    supplier_detail_pricing_tier: "Tier de precio activo",
    supplier_detail_margin: "Margen",
    supplier_detail_pricing_rule: "Regla aplicada",
    supplier_detail_add_to_order: "Agregar a la orden",
    supplier_detail_qty_required: "Selecciona al menos una cantidad.",
    supplier_detail_added_toast: "{n} ítem(s) agregado(s) a la orden",
    supplier_detail_no_variants: "Este estilo aún no tiene variantes cargadas.",
    supplier_detail_pricing_ladder: "Escalera de precios",
    supplier_detail_pricing_fallback: "⚠ Sin regla de precios configurada — usando markup por defecto.",
    supplier_detail_visual_only_hint: "Catálogo solo de referencia visual — abre el sitio del proveedor para comprar y captura el costo mayorista manualmente.",
    supplier_detail_manual_cost_label: "Costo mayorista (manual)",
    // Catalog picker
    catalog_title: "Catálogo de Productos",
    catalog_search_placeholder: "Buscar por SKU, nombre o descripción...",
    catalog_all_categories: "Todas",
    catalog_section_favorites: "Favoritos de Rawen's",
    catalog_section_new: "Productos Nuevos",
    catalog_section_bestsellers: "Más Vendidos",
    catalog_results: "resultados",
    catalog_load_error: "No se pudo cargar el catálogo",
    catalog_hero_sections_title: "DESTACADOS",
    catalog_categories_title: "CATEGORÍAS",
    catalog_products_word: "productos",
    catalog_view_product_btn: "Ver producto",
    catalog_back_to_catalog: "Volver al catálogo",
    catalog_no_results: "Ningún producto coincide con este filtro.",
    catalog_back: "Volver",
    catalog_back_to_order: "Volver a la orden",
    // Full dynamic catalog (Feb 2026)
    catalog_full_title: "Catálogo de Productos",
    catalog_full_subtitle: "Explora todo el catálogo por categoría, marca o palabra clave",
    catalog_pane_categories: "CATEGORÍAS",
    catalog_pane_brands: "MARCAS",
    catalog_pane_all: "Todas",
    catalog_filter_brand: "Marca",
    catalog_filter_category: "Categoría",
    catalog_filter_subcategory: "Subcategoría",
    catalog_filter_clear: "Limpiar filtros",
    catalog_searching: "Buscando…",
    catalog_of_total: "de",
    catalog_pagination_prev: "Anterior",
    catalog_pagination_next: "Siguiente",
    catalog_pagination_page: "Página",
    catalog_colors_more: "más",
    catalog_empty_state_title: "Sin catálogo cargado todavía",
    catalog_empty_state_hint: "El motor está sincronizando el catálogo por primera vez. Espera unos minutos y refresca.",
    catalog_sync_ready: "Catálogo listo",
    catalog_sync_running: "Sincronizando…",
    catalog_sync_error: "Error de sincronización",
    catalog_admin_panel_title: "Motor del catálogo",
    catalog_admin_run_sync: "Ejecutar sincronización",
    catalog_admin_force_sync: "Forzar sincronización",
    catalog_admin_last_synced: "Última sincronización",
    catalog_admin_scheduled: "Sincronización diaria automática 03:00 America/Chicago",
    catalog_admin_products: "productos",
    catalog_detail_live_pricing: "Precios en vivo",
    catalog_detail_live_pricing_hint: "Precio y disponibilidad se consultan en tiempo real al proveedor.",
    catalog_detail_inventory: "Inventario disponible",
    catalog_detail_inventory_by_warehouse: "Por almacén",
    catalog_detail_no_inventory: "Sin inventario disponible en este momento.",
    // Catalog detail
    catalog_detail_category: "Categoría",
    catalog_detail_description: "Descripción",
    catalog_detail_colors: "Colores disponibles",
    catalog_detail_sizes: "Tallas disponibles",
    catalog_detail_qty_matrix: "Cantidad por color y talla",
    catalog_detail_qty_per_size: "Cantidad por talla",
    catalog_detail_active_color_total: "Subtotal color",
    catalog_detail_select_sizes: "Selecciona tallas y cantidades",
    catalog_detail_tap_size_hint: "Toca una talla para agregarla al pedido",
    catalog_detail_gallery: "Galería",
    catalog_detail_summary: "Resumen",
    catalog_detail_decoration_method: "Método de decoración",
    // ── Order Success Panel (post-save quick share actions) ──
    order_success_title: "Orden creada exitosamente",
    order_success_number: "Orden",
    order_success_customer: "Cliente",
    order_success_delivery: "Entrega",
    order_success_total: "Total",
    order_success_share_title: "Copia del cliente · Compartir",
    order_success_print: "Imprimir",
    order_success_print_hint: "Usa Ctrl+P / ⌘+P en la pestaña abierta para imprimir.",
    order_success_download_pdf: "Descargar PDF",
    order_success_send_email: "Enviar por Email",
    order_success_send_sms: "Enviar por SMS",
    order_success_send_whatsapp: "Enviar por WhatsApp",
    order_success_no_phone: "El cliente no tiene teléfono registrado.",
    order_success_phone_hint: "SMS y WhatsApp requieren un número de teléfono en el cliente.",
    order_success_open_full: "Ver / editar orden completa",
    catalog_detail_select_placeholder: "Seleccionar",
    done: "Listo",
    catalog_detail_color: "Color",
    catalog_detail_size: "Talla",
    catalog_detail_notes: "Notas",
    catalog_detail_selling_price: "Precio de venta",
    catalog_detail_cost: "Costo",
    catalog_detail_base_cost: "Costo Base",
    catalog_detail_logo_location: "Posición",
    catalog_detail_price_placeholder_hint: "Placeholder — se conectará al precio real en Phase 2.",
    catalog_detail_total_qty: "Cantidad total",
    catalog_detail_lines_preview: "Líneas a generar",
    catalog_detail_add_to_order: "Agregar a la orden",
    catalog_detail_qty_required: "Indica al menos una cantidad mayor a 0",
    catalog_detail_added_toast: "{n} ítem(s) agregado(s) a la orden",
    // Service form
    service_form_title: "Agregar Servicio",
    service_form_type_label: "Tipo de servicio",
    service_form_qty_label: "Cantidad",
    service_form_price_label: "Precio unitario",
    service_form_cost_label: "Costo unitario",
    service_form_notes_label: "Notas",
    service_form_add_btn: "Agregar servicio",
    service_form_type_required: "Selecciona un tipo de servicio",
    service_form_qty_required: "La cantidad debe ser mayor a 0",
    service_form_added_toast: "Servicio agregado a la orden",
    service_load_error: "No se pudo cargar la lista de servicios",
    // Order item badges (catalog + service items)
    order_item_from_catalog_badge: "Del Catálogo",
    order_item_service_badge: "Servicio",
    order_item_catalog_color: "Color",
    order_item_catalog_size: "Talla",
    order_item_service_type: "Tipo",
    // Placeholder card — futuro módulo de automatización
    settings_automation_card_title: "Automatización",
    settings_automation_card_desc: "Reglas, notificaciones automáticas e integraciones con servicios externos",
    settings_coming_soon_badge: "Próximamente",
    // Pricing Engine (2026-02-15)
    settings_pricing_card_title: "Motor de Precios",
    settings_pricing_card_desc: "Reglas de precio universales — proveedores, marcas, categorías, cantidades y clientes. Con simulador en vivo.",
    pricing_title: "Motor Universal de Precios",
    pricing_subtitle: "Reglas dinámicas para cualquier proveedor, marca o categoría. Cada módulo del ERP consume este motor.",
    pricing_new_rule: "Nueva regla",
    pricing_no_rules: "No hay reglas configuradas. Crea la primera regla.",
    pricing_rule_priority: "Prioridad",
    pricing_rule_strategy: "Estrategia",
    pricing_rule_name: "Nombre",
    pricing_rule_default: "Default",
    pricing_rule_active: "Activa",
    pricing_rule_inactive: "Inactiva",
    pricing_rule_filters: "Filtros",
    pricing_rule_min_profit: "Piso de ganancia ($)",
    pricing_rule_max_discount: "Descuento máx (%)",
    pricing_rule_notes: "Notas",
    pricing_edit: "Editar",
    pricing_delete: "Eliminar",
    pricing_toggle: "Activar/Desactivar",
    pricing_form_new_title: "Nueva regla de precio",
    pricing_form_edit_title: "Editar regla de precio",
    pricing_form_section_basic: "Configuración básica",
    pricing_form_section_strategy: "Estrategia de precio",
    pricing_form_section_filters: "Aplicabilidad (filtros)",
    pricing_form_section_clamps: "Restricciones de ganancia",
    pricing_form_section_meta: "Metadatos",
    pricing_form_strategy_hint_markup: "Precio = costo × (1 + markup%). Simple y predecible.",
    pricing_form_strategy_hint_quantity_break: "Tiers escalonados por cantidad. Cada tier lleva su propio markup% o precio unitario.",
    pricing_form_strategy_hint_fixed_price: "Precio fijo (ignora costo). Útil para servicios.",
    pricing_form_strategy_hint_formula: "Expresión aritmética con variables cost, qty, msrp. Ej: cost * 1.4 + 2",
    pricing_form_strategy_hint_passthrough: "Precio = costo (venta al costo).",
    pricing_form_markup_pct: "Markup (%)",
    pricing_form_fixed_price: "Precio unitario ($)",
    pricing_form_formula_expr: "Expresión",
    pricing_form_break_min_qty: "Cantidad mín",
    pricing_form_break_markup: "Markup %",
    pricing_form_break_unit_price: "Precio unitario",
    pricing_form_break_label: "Etiqueta",
    pricing_form_break_add: "+ Agregar tier",
    pricing_form_break_remove: "Quitar",
    pricing_form_min_profit_hint: "Ganancia mínima en $. Si el precio calculado deja menos, sube el precio al piso.",
    pricing_form_max_discount_hint: "Descuento máximo permitido sobre MSRP (o precio pre-clamp). Ej: 25 significa que nunca baja más del 25%.",
    pricing_form_filter_hint: "Todos los filtros son OPCIONALES. Vacío = aplica a todo. Más específica gana.",
    pricing_filter_connector: "Proveedor / Connector",
    pricing_filter_source_type: "Tipo de origen",
    pricing_filter_brand: "Marca",
    pricing_filter_category: "Categoría",
    pricing_filter_style: "Estilo",
    pricing_filter_sku: "SKU",
    pricing_filter_color: "Color",
    pricing_filter_size: "Talla",
    pricing_filter_customer_category: "Categoría de cliente",
    pricing_filter_min_quantity: "Cantidad mínima",
    pricing_form_priority_hint: "Números mayores ganan cuando hay empate de especificidad.",
    pricing_form_is_default_hint: "Solo una regla puede ser default (fallback global).",
    pricing_sim_title: "Simulador en vivo",
    pricing_sim_subtitle: "Prueba precios sin guardar. Se recalcula en cada cambio.",
    pricing_sim_result: "Resultado",
    pricing_sim_unit_price: "Precio unitario",
    pricing_sim_total: "Total línea",
    pricing_sim_margin: "Margen",
    pricing_sim_rule: "Regla aplicada",
    pricing_sim_clamp_min_profit: "Piso de ganancia activo",
    pricing_sim_clamp_max_discount: "Tope de descuento activo",
    pricing_sim_fallback: "Fallback (ninguna regla coincide → markup 40%)",
    pricing_sim_reset: "Limpiar",
    pricing_sim_cost_placeholder: "Costo del proveedor",
    pricing_sim_qty_placeholder: "Cantidad",
    pricing_confirm_delete: "¿Eliminar esta regla de precio?",
    // Attribution chip in OrderDetailsModal (2026-02-15)
    order_item_rule_label: "Regla",
    order_item_rule_unknown: "regla eliminada",
    order_item_rule_manual: "Precio manual",
    order_item_rule_manual_hint: "Precio ingresado a mano — sin regla del motor.",
    order_item_rule_open_hint: "Abrir en el Motor de Precios",
    order_item_rule_none: "Sin regla",
    // Roles & Permisos (Sprint RBAC v2)
    settings_roles_card_title: "Roles y Permisos",
    settings_roles_card_desc: "Crea roles personalizados, asigna varios por usuario y controla los permisos módulo por módulo",
    roles_title: "Roles y Permisos",
    roles_subtitle: "Motor flexible de RBAC — múltiples roles por usuario, overrides por usuario y semilla de roles del sistema",
    roles_new_btn: "Nuevo rol",
    roles_none: "Aún no hay roles.",
    role_badge_system: "Sistema",
    role_badge_admin: "Administrador",
    role_perms_count: "módulos con permisos",
    role_edit: "Editar",
    role_duplicate: "Duplicar",
    role_delete: "Eliminar",
    role_name: "Nombre",
    role_description: "Descripción",
    role_permissions: "Matriz de permisos",
    role_form_admin_note: "El rol Administrador siempre tiene acceso total. Sus permisos no se pueden reducir.",
    role_form_system_note: "Este es un rol del sistema. Puedes editar sus permisos y renombrarlo, pero no eliminarlo.",
    perm_module_all: "todo el módulo",
    role_save_ok: "Rol guardado",
    role_delete_confirm: "¿Eliminar este rol? Los usuarios que lo tengan asignado quedarán sin él.",
    role_duplicated: "Rol duplicado",
    // Employees — roles multi-select + overrides
    employee_roles_label: "Roles asignados",
    employee_roles_hint: "Un usuario puede tener varios roles. Sus permisos son la UNIÓN de todos.",
    employee_overrides_title: "Permisos específicos del usuario (override)",
    employee_overrides_hint: "Otorga o revoca permisos individuales sin necesidad de crear otro rol.",
    employee_overrides_none: "Sin overrides — los permisos vienen únicamente de los roles.",
    employee_override_grant: "Conceder extra",
    employee_override_revoke: "Revocar",
    employee_effective_permissions: "Permisos efectivos (rol + override)",
    role_legacy_field: "Rol legado (texto libre)",
    // Permission module labels (ES)
    perm_mod_customers: "Clientes",
    perm_mod_orders: "Órdenes",
    perm_mod_catalog: "Catálogo",
    perm_mod_production: "Producción",
    perm_mod_tasks: "Tareas",
    perm_mod_calendar: "Calendario",
    perm_mod_dashboard: "Tablero",
    perm_mod_reports: "Reportes",
    perm_mod_inventory: "Inventario",
    perm_mod_purchasing: "Compras",
    perm_mod_financial_dashboard: "Dashboard Financiero",
    perm_mod_costs: "Costos",
    perm_mod_profit: "Ganancia",
    perm_mod_suppliers: "Proveedores",
    perm_mod_hr: "Recursos Humanos",
    perm_mod_crm: "CRM",
    perm_mod_users: "Usuarios",
    perm_mod_roles: "Roles",
    perm_mod_settings: "Configuración",
    perm_mod_customer_copy: "Copia al Cliente (Print/PDF/Email/SMS/WhatsApp)",
    // Permission action labels (ES)
    perm_act_view: "Ver",
    perm_act_view_all: "Ver todo",
    perm_act_estimates_all: "Todos los Estimates",
    perm_act_create: "Crear",
    perm_act_edit: "Editar",
    perm_act_delete: "Eliminar",
    perm_act_approve: "Aprobar",
    perm_act_export: "Exportar",
    perm_act_print: "Imprimir",
    perm_act_send: "Enviar",
    smart_products_title: "Catálogo de Productos",
    smart_products_subtitle: "Define qué información debe pedir GP cuando cada producto se agregue a una orden",
    smart_products_new_btn: "Nuevo producto",
    smart_products_empty: "Aún no hay productos en el catálogo. Crea el primero.",
    smart_products_search_placeholder: "Buscar por nombre o código…",
    smart_products_required_count: "campos activos",
    smart_products_section_basic: "Información básica",
    smart_products_section_fields: "Campos requeridos para este producto",
    smart_products_section_fields_hint: "Activa los campos que GP debe pedir cuando este producto se agregue a una orden. Mín. 0 · Máx. 14.",
    smart_products_orders_pending_note: "Próximamente: el flujo de Órdenes consumirá esta configuración para pedir únicamente los campos activados. Por ahora la integración está pendiente.",
    smart_products_orders_ready_note: "Integrado: al crear una Orden y seleccionar este producto, GP completará automáticamente SKU, nombre, marca, modelo, proveedor, unidad y tiempo de producción, y solo pedirá los campos activados aquí.",
    smart_products_default_model: "Modelo por defecto",
    smart_products_default_model_hint: "Ej. 29M, P150, etc. Se heredará al crear una Orden.",
    smart_products_description: "Descripción",
    smart_products_description_hint: "Descripción que se mostrará en la Orden cuando se seleccione este producto.",
    smart_products_production_time_unit_minutes: "Minutos",
    order_item_smart_product: "Producto del Catálogo (Smart Product)",
    order_item_smart_product_placeholder: "— Seleccionar producto inteligente —",
    order_item_inherits_label: "Heredado del producto",
    order_item_no_smart_product_hint: "Selecciona un producto del catálogo para autocompletar.",
    smart_products_unit_of_measure: "Unidad de medida",
    smart_products_item_type: "Tipo de ítem",
    smart_products_code: "Código (SKU)",
    smart_products_code_hint: "opcional, único",
    smart_products_uom: "Unidad de medida",
    smart_products_default_brand: "Marca por defecto",
    smart_products_default_supplier: "Proveedor por defecto",
    smart_products_field_brand: "Marca",
    smart_products_field_model: "Modelo",
    smart_products_field_color: "Color",
    smart_products_field_size: "Talla",
    smart_products_field_quantity: "Cantidad",
    smart_products_field_decoration_method: "Método de decoración",
    smart_products_field_logo_location: "Ubicación del logo",
    smart_products_field_material: "Material",
    smart_products_field_width: "Ancho",
    smart_products_field_height: "Alto",
    smart_products_field_thickness: "Espesor",
    smart_products_field_installation: "Instalación",
    smart_products_field_led: "LED",
    smart_products_field_comments: "Comentarios",
    // Product Taxonomy (Categorías + Subcategorías de Productos)
    tab_product_categories: "Categorías de Productos",
    tab_product_subcategories: "Subcategorías",
    smart_products_category: "Categoría",
    smart_products_subcategory: "Subcategoría",
    smart_products_image: "Imagen del producto",
    smart_products_image_hint: "JPG / PNG / WEBP — máx. 8 MB",
    smart_products_image_upload: "Subir imagen",
    smart_products_image_remove: "Quitar imagen",
    smart_products_image_uploading: "Subiendo…",
    smart_products_production_time: "Tiempo promedio de producción",
    smart_products_production_time_unit_hours: "Horas",
    smart_products_production_time_unit_days: "Días",
    product_taxonomy_pick_parent: "Selecciona una categoría",
    no_results: "Sin resultados",
    new_record: "Nuevo registro",
    no_records: "Aún no hay registros. Creá el primero.",
    name_required: "Nombre requerido",
    back: "Volver",
    activate: "Activar",
    deactivate: "Desactivar",
    back_to_settings: "← Volver a Configuración",
    financial_config_title: "Configuración Financiera",
    financial_config_subtitle: "Gestión de categorías y productos · costo promedio en USD",
    tab_categories: "Categorías",
    tab_financial_products: "Productos",
    category: "Categoría",
    category_name: "Nombre de la categoría",
    new_category: "Nueva categoría",
    edit_category: "Editar categoría",
    no_categories: "Aún no hay categorías. Crea la primera.",
    new_financial_product: "Nuevo producto",
    edit_financial_product: "Editar producto",
    financial_product_name: "Nombre del producto",
    average_cost: "Costo Promedio (USD)",
    long_description: "Descripción",
    long_description_hint: "Notas sobre materiales, procesos u otra información útil (opcional)",
    no_financial_products: "Aún no hay productos. Crea el primero.",
    active: "Activo",
    inactive: "Inactivo",
    all_statuses: "Todos los estados",
    active_only: "Solo activos",
    inactive_only: "Solo inactivos",
    no_active_category_warning: "Crea al menos una categoría activa para poder crear productos",
    select_category_placeholder: "Selecciona una categoría",
    cost_must_be_non_negative: "El costo no puede ser negativo",
    saved_ok: "Guardado correctamente",
    deleted_ok: "Eliminado correctamente",
    state_changed_ok: "Estado actualizado",

    // Product Types (Sprint 2)
    product_types_title: "Tipos de Producto",
    product_types_subtitle: "Catálogo de tipos base · clasifica los productos del sistema",
    new_product_type: "Nuevo tipo",
    edit_product_type: "Editar tipo",
    product_type_name: "Nombre del tipo",
    product_type_description: "Descripción",
    no_product_types: "Aún no hay tipos de producto. Crea el primero.",
    product_type: "Tipo de Producto",
    product_type_optional: "Tipo de producto (opcional)",
    select_product_type_placeholder: "— Sin tipo —",
    type_fields_section: "Campos del tipo",
    field_schema_section: "Campos personalizados",
    field_key: "Clave",
    field_label: "Etiqueta",
    field_type: "Tipo",
    field_type_text: "Texto",
    field_type_number: "Número",
    field_type_select: "Lista (opciones)",
    field_unit: "Unidad",
    field_options: "Opciones (separadas por coma)",
    field_required: "Requerido",
    add_field: "+ Agregar campo",
    remove_field: "Quitar",
    field_key_hint: "Solo letras minúsculas, números y guion bajo. Ej: ancho, hourly_rate",

    // Sprint 4 — Catalog pricing & Order ↔ Product linkage
    sku: "Código (SKU)",
    sku_hint: "Código corto del catálogo. Ej: LOGO-01",
    suggested_price: "Precio sugerido",
    suggested_margin: "Margen sugerido",
    suggested_margin_hint: "Calculado: (precio − costo) / precio × 100",
    catalog_product_optional: "Producto del catálogo (opcional)",
    select_catalog_product: "— Sin producto —",
    item_unit_price: "Precio unit.",
    item_unit_cost: "Costo unit.",
    item_subtotal: "Subtotal",
    item_cost_total: "Costo",
    item_profit: "Profit",
    order_subtotal: "Subtotal",
    order_total_cost: "Costo total",
    order_total_profit: "Profit total",
    order_margin: "Margen",
    manual_item: "Ítem manual",

    // Sprint 5.2 — V2 Master Catalog (Catálogo Maestro)
    v2_master_section: "Catálogo Maestro · Atributos (opcionales)",
    v2_master_hint: "Estos atributos describen el producto permanente, no la producción de una orden.",
    field_item_type: "Tipo de ítem",
    field_brand: "Marca",
    field_supplier: "Proveedor",
    field_color: "Color",
    field_size: "Talla",
    field_unit_of_measure: "Unidad de medida",
    field_model: "Modelo",
    field_requires_dimensions: "Requiere medidas (ancho × alto)",
    field_requires_dimensions_hint: "Marca esto para banners, vinilos, materiales en lámina o cualquier producto vendido por ft². Las órdenes preguntarán automáticamente Ancho × Alto × Grosor.",
    no_selection: "— Sin seleccionar —",
    legacy_product_types_notice: "Tipos de Producto (legado): los productos viejos siguen funcionando. Los nuevos productos deben usar el Catálogo Maestro de abajo.",

    // Sprint 5.3 — Order item structured production fields
    v2_production_section: "Producción (Sprint 5.3)",
    field_decoration_method: "Método de decoración",
    field_logo_location: "Ubicación del logo",
    field_colors_used: "Colores usados",
    field_colors_used_hint: "Ej: Black + White (2c), CMYK Full Color…",
    field_artwork_url: "URL del arte",
    field_artwork_url_hint: "Link a Drive / Dropbox / archivo de diseño",
    field_customer_notes: "Notas del cliente",
    field_width: "Ancho",
    field_height: "Alto",
    field_thickness: "Grosor",
    field_area_sqft: "Área (ft²)",
    field_area_sqft_auto: "Auto: ancho × alto",
    dimensions_section: "Medidas",

    // Sprint 5.4 — CSV importer for the Master Catalog
    csv_import_button: "Importar CSV",
    csv_import_title: "Importar Catálogo desde CSV",
    csv_import_subtitle: "Crea o actualiza productos del Catálogo Maestro en lote.",
    csv_import_step_1: "1 · Descarga la plantilla",
    csv_import_template_btn: "Descargar plantilla",
    csv_import_template_hint: "Incluye los encabezados y 2 filas de ejemplo. Usa nombres exactos para Categoría, Marca, Color, etc.",
    csv_import_step_2: "2 · Elige el modo de coincidencia",
    csv_import_match_sku: "Por SKU — si el SKU ya existe, actualiza; si no, crea",
    csv_import_match_name: "Por Nombre — si el nombre ya existe, actualiza; si no, crea",
    csv_import_match_create_only: "Crear solo — rechaza si el SKU o Nombre ya existe",
    csv_import_step_3: "3 · Carga el archivo y valida",
    csv_import_validate_btn: "Validar archivo",
    csv_import_step_4: "4 · Revisa y ejecuta",
    csv_import_execute_btn: "Confirmar e importar",
    csv_import_executing: "Importando…",
    csv_import_validating: "Validando…",
    csv_import_summary_rows: "Filas",
    csv_import_summary_to_create: "Crear",
    csv_import_summary_to_update: "Actualizar",
    csv_import_summary_errors: "Errores",
    csv_import_no_errors: "Sin errores. Listo para importar.",
    csv_import_has_errors: "Corrige los errores en el CSV antes de importar.",
    csv_import_result_created: "Creados",
    csv_import_result_updated: "Actualizados",
    csv_import_result_skipped: "Omitidos",
    csv_import_row_label: "Fila",
    csv_import_action_create: "CREAR",
    csv_import_action_update: "ACTUALIZAR",
    csv_import_action_error: "ERROR",
    csv_import_close: "Cerrar",
    csv_import_no_file: "Selecciona un archivo CSV primero.",
    csv_import_success: "Importación completada.",

    // Sprint 5.5 — search, filters, status, where-used
    products_search_placeholder: "Buscar por nombre, SKU o modelo…",
    products_filter_brand: "Marca",
    products_filter_color: "Color",
    products_filter_size: "Talla",
    products_filter_supplier: "Proveedor",
    products_filter_all: "Todos",
    products_filter_status: "Estado",
    products_status_active: "Activos",
    products_status_inactive: "Inactivos",
    products_status_archived: "Archivados",
    products_status_visible: "Activos + Inactivos",
    products_status_any: "Cualquiera (incluye archivados)",
    products_filters_reset: "Limpiar filtros",
    products_no_matches: "Ningún producto coincide con los filtros aplicados.",
    product_status_label: "Estado",
    status_active: "Activo",
    status_inactive: "Inactivo",
    status_archived: "Archivado",
    archive_product: "Archivar",
    archive_product_confirm: "¿Archivar este producto? No se podrá usar en órdenes nuevas, pero las órdenes históricas seguirán mostrándolo.",
    where_used_title: "¿Dónde se usa este producto?",
    where_used_orders_count: "órdenes usan este producto",
    where_used_no_orders: "Este producto no se usa en ninguna orden.",
    where_used_recent: "Órdenes recientes",
    where_used_archive_blocked: "Este producto se usa en {n} órdenes históricas. Al archivar, esas órdenes lo seguirán mostrando con el nombre actual, pero ya no podrás seleccionarlo en órdenes nuevas.",

    // ─── Sprint 7B — Commercial Docs (Estimates / Invoices / Credit Notes / Work Orders / Customers / Company Info) ───
    loading_ellipsis: "Cargando…",
    saving_ellipsis: "Guardando…",
    remove: "Quitar",
    empty_no_events: "Sin eventos.",
    generic_ok: "OK",
    generic_error: "Error",
    filter_all_f: "Todas",
    filter_all_status_f: "Todos los estados",
    results_count: "{n} resultado{s}",
    action_pdf: "PDF",
    action_email_icon: "✉ Email",
    action_whatsapp: "WhatsApp",
    action_print: "🖨 Imprimir",
    action_duplicate: "⧉ Duplicar",
    action_edit_icon: "✎ Editar",
    action_delete_icon: "🗑 Eliminar",
    action_cancel_icon: "✕ Cancelar",
    action_reactivate_icon: "↺ Reactivar",
    action_follow_up_icon: "⏰ Follow-up",
    action_approve_icon: "✓ Aprobar",
    // Estimate statuses
    est_status_draft: "Borrador",
    est_status_sent: "Enviado",
    est_status_approved: "Aprobado",
    est_status_expired: "Vencido",
    est_status_cancelled: "Cancelado",
    // Invoice statuses
    inv_status_unpaid: "Sin pagar",
    inv_status_partial_paid: "Pago parcial",
    inv_status_paid: "Pagado",
    inv_status_due_on_delivery: "Pago c/entrega",
    inv_status_due_on_delivery_full: "Pago contra entrega",
    inv_status_cancelled: "Cancelado",
    inv_status_credited: "Acreditado",
    // Work Order statuses (Commercial view)
    wo_status_design: "En diseño",
    wo_status_waiting_approval: "Esperando aprobación",
    wo_status_production: "En producción",
    wo_status_ready: "Lista",
    wo_status_delivered: "Entregada",

    // ─── Estimates Panel ───
    est_panel_title: "Cotizaciones",
    est_panel_subtitle_all: "Vista completa — todas las cotizaciones",
    est_panel_subtitle_mine: "Tus cotizaciones",
    est_panel_new_btn: "+ Nueva cotización",
    est_panel_search_placeholder: "Buscar por número, cliente, teléfono, email…",
    est_panel_empty: "No hay cotizaciones con esos filtros.",
    est_panel_load_err: "No se pudieron cargar los estimates",
    est_panel_open_err: "No se pudo abrir el estimate",
    est_panel_pdf_err: "No se pudo generar el PDF",
    est_panel_dup_err: "No se pudo duplicar",
    est_panel_dup_ok: "Duplicado como {n}",
    est_panel_col_contact: "Contacto",
    est_panel_col_office: "Oficina",
    est_panel_col_sales_rep: "Sales Rep",
    est_panel_col_total: "Total",
    est_panel_col_created: "Creada",
    est_panel_col_expires: "Vence",
    est_panel_col_client: "Cliente",
    est_panel_col_status: "Estado",
    est_panel_action_duplicate_title: "Duplicar",
    est_panel_action_email_title: "Email",
    est_panel_action_wa_title: "WhatsApp",

    // ─── Estimate Form ───
    est_form_required_company: "El nombre de la empresa (cliente) es obligatorio.",
    est_form_required_office: "Selecciona una oficina.",
    est_form_required_items: "Agrega al menos un producto o servicio.",
    est_form_beanies_min: "El mínimo combinado de Beanies es 6 (puedes mezclar modelos y colores).",
    est_form_pool_min: "El mínimo combinado de {pool} es {min} (puedes mezclar modelos y colores).",
    add_item_vinyl_title: "Printed Vinyl",
    add_item_vinyl_desc: "Calculadora de vinyl impreso: medidas, material, laminado, acabados y paneles automáticos.",
    vinyl_calc_title: "Vinyl Calculator",
    vinyl_material: "Material",
    vinyl_size: "Tamaño",
    vinyl_width: "Ancho",
    vinyl_height: "Alto",
    vinyl_qty: "Cantidad",
    vinyl_add_size: "+ Agregar otro tamaño",
    vinyl_remove_size: "Quitar",
    vinyl_finishing: "Acabados",
    vinyl_lamination: "Lamination (tabla laminada)",
    vinyl_finished_area: "Área terminada",
    vinyl_production_area: "Área de producción",
    vinyl_tier: "Tier",
    vinyl_paneling: "Paneles",
    vinyl_panels_label: "paneles",
    vinyl_no_panels: "sin paneles",
    vinyl_base_charge: "Cargo vinyl",
    vinyl_min_applied: "mínimo $30 aplicado",
    vinyl_total: "Total",
    vinyl_cancel: "Cancelar",
    vinyl_add_to_estimate: "Agregar al Estimate",
    vinyl_invalid: "Revisa las medidas: ancho, alto y cantidad deben ser mayores a 0.",
    add_item_banner_title: "Banner 13 oz",
    add_item_banner_desc: "Calculadora de banners: medidas, grommets, refuerzo, laminado y paneles automáticos.",
    banner_calc_title: "Banner Calculator",
    banner_size: "Tamaño",
    banner_width: "Ancho",
    banner_height: "Alto",
    banner_qty: "Cantidad",
    banner_add_size: "+ Agregar otro tamaño",
    banner_remove_size: "Quitar",
    banner_finished_area: "Área terminada",
    banner_production_area: "Área de producción",
    banner_tier: "Tier",
    banner_base_charge: "Cargo banner",
    banner_min_applied: "mínimo $30 aplicado",
    banner_total: "Total",
    banner_cancel: "Cancelar",
    banner_add_to_estimate: "Agregar al Estimate",
    banner_invalid: "Revisa las medidas: ancho, alto y cantidad deben ser mayores a 0.",
    est_form_updated_ok: "Estimate actualizado",
    est_form_created_ok: "Estimate creado ({n})",
    est_form_save_err: "Error al guardar",
    est_form_title_new: "Nueva cotización",
    est_form_title_edit: "Editar cotización {n}",
    est_form_sales_rep_hint: "Sales Rep: {name} · Se asigna automáticamente.",
    est_form_field_office: "Oficina",
    est_form_field_delivery: "Fecha de entrega esperada",
    est_form_field_followup: "Follow-up (opcional)",
    est_form_section_customer: "CLIENTE",
    est_form_field_company: "Empresa *",
    est_form_field_contact: "Contacto",
    est_form_field_phone: "Teléfono",
    est_form_field_email: "Email",
    est_form_customer_hint_title: "CLIENTE EXISTENTE ENCONTRADO",
    est_form_customer_hint_apply: "Usar este cliente",
    est_form_section_items: "PRODUCTOS / SERVICIOS",
    est_form_add_item: "+ Agregar producto",
    est_form_open_catalog_btn: "📚 Catálogo",
    est_form_items_empty: "No hay productos aún. Usa",
    est_form_add_item_hint_bold: "+ Agregar producto",
    est_form_item_unnamed: "Sin nombre",
    est_form_item_edit_custom: "✎ Editar",
    est_form_item_remove: "Quitar",
    est_form_field_discount_type: "Tipo de descuento",
    est_form_discount_amount: "Monto ($)",
    est_form_discount_percent: "Porcentaje (%)",
    est_form_field_discount_value: "Valor descuento",
    est_form_field_tax: "Impuesto",
    est_form_tax_exempt_label: "Tax Exempt",
    est_form_field_customer_notes: "Notas para el cliente (se imprimen)",
    est_form_field_internal_notes: "Notas internas (nunca impresas)",
    est_form_field_followup_notes: "Notas del seguimiento",
    est_form_summary_subtotal: "Subtotal",
    est_form_summary_discount: "Descuento",
    est_form_summary_tax_exempt: "Tax (Exento)",
    est_form_summary_tax_rate: "Sales Tax ({pct}%)",
    est_form_summary_total: "TOTAL",
    est_form_submit_new: "Crear cotización",
    est_form_submit_edit: "Guardar cambios",

    // ─── Estimate Detail Modal ───
    est_detail_load_err: "No se pudo cargar el estimate",
    est_detail_toast_send: "Estimate marcado como Enviado",
    est_detail_toast_approve: "Estimate Aprobado",
    est_detail_toast_cancel: "Estimate Cancelado",
    est_detail_toast_duplicate: "Duplicado como {n}",
    est_detail_action_err: "No se pudo ejecutar {action}",
    est_detail_followup_ok: "Follow-up guardado",
    est_detail_followup_err: "No se pudo guardar el follow-up",
    est_detail_pdf_err: "No se pudo generar el PDF",
    est_detail_print_err: "No se pudo imprimir",
    est_detail_convert_confirm: "Al convertir a Factura, este Estimate quedará bloqueado (solo Duplicar). ¿Continuar?",
    est_detail_invoice_created: "Factura {n} creada",
    est_detail_sc_prompt: "Este cliente tiene ${avail} de Store Credit. ¿Aplicar ${apply} a la Factura {n} ahora?",
    est_detail_sc_applied: "Store Credit aplicado: ${amt}",
    est_detail_sc_notes: "Aplicación automática al convertir Estimate → Invoice",
    est_detail_sc_err: "No se pudo aplicar Store Credit",
    est_detail_convert_err: "No se pudo convertir a factura",
    est_detail_softdelete_confirm: "¿Eliminar este Estimate? (soft-delete, admin)",
    est_detail_softdelete_ok: "Estimate eliminado",
    est_detail_softdelete_err: "No se pudo eliminar",
    est_detail_label: "EST / DETAIL",
    est_detail_invoiced_badge: "FACTURADO · {n}",
    est_detail_send_btn: "Marcar como Enviado",
    est_detail_convert_btn: "→ Convertir a Factura",
    est_detail_converting_btn: "Convirtiendo…",
    est_detail_view_invoice_btn: "Ver factura {n}",
    est_detail_cancel_confirm: "¿Cancelar este estimate?",
    est_detail_followup_date_label: "FECHA FOLLOW-UP",
    est_detail_followup_notes_label: "NOTAS",
    est_detail_section_customer: "Cliente",
    est_detail_section_meta: "Meta",
    est_detail_section_items: "Ítems",
    item_group_variants_count: "{n} variantes",
    item_group_variants_count_one: "1 variante",
    item_group_total_units: "{q}u",
    item_variant_label: "{color} · {size}",
    est_detail_section_customer_notes: "Notas al cliente (se imprimen)",
    est_detail_section_internal_notes: "Notas internas (no se imprimen)",
    est_detail_section_summary: "Resumen",
    est_detail_section_history: "Historial",
    est_detail_meta_office: "Oficina:",
    est_detail_meta_sales_rep: "Sales Rep:",
    est_detail_meta_created: "Creada:",
    est_detail_meta_expires: "Vence:",
    est_detail_meta_delivery: "Entrega:",
    est_detail_meta_followup: "Follow-up:",
    est_detail_summary_discount_pct: "Descuento ({pct}%)",
    est_detail_summary_discount: "Descuento",
    est_detail_summary_subtotal: "Subtotal",
    est_detail_summary_tax_exempt: "Tax (Exento)",
    est_detail_summary_tax_rate: "Sales Tax ({pct}%)",

    // ─── Invoices Panel ───
    inv_panel_title: "Facturas",
    inv_panel_subtitle_all: "Vista completa — todas las facturas",
    inv_panel_subtitle_mine: "Tus facturas",
    inv_panel_note_a: "Solo se crean convirtiendo un Estimate aprobado.",
    inv_panel_note_b: "Snapshot inmutable · sin ediciones directas.",
    inv_panel_search_placeholder: "Buscar por número, EST origen, cliente, teléfono…",
    inv_panel_empty: "No hay facturas con esos filtros.",
    inv_panel_load_err: "No se pudieron cargar las facturas",
    inv_panel_pdf_err: "No se pudo generar el PDF",
    inv_panel_col_invoice: "Factura",
    inv_panel_col_origin: "Origen",
    inv_panel_col_client: "Cliente",
    inv_panel_col_status: "Estado",
    inv_panel_col_total: "Total",
    inv_panel_col_paid: "Pagado",
    inv_panel_col_balance: "Balance",
    inv_panel_col_created: "Creada",

    // ─── Invoice Detail Modal ───
    inv_detail_load_err: "No se pudo cargar la factura",
    inv_detail_pay_invalid_amount: "Ingresá un monto válido",
    inv_detail_pay_missing_method: "Seleccioná un método de pago",
    inv_detail_pay_ok: "Pago registrado",
    inv_detail_pay_err: "No se pudo registrar el pago",
    inv_detail_cn_ok: "Nota de crédito emitida",
    inv_detail_cn_sc_ok: "Nota de crédito emitida como Store Credit",
    inv_detail_cn_err: "No se pudo emitir la nota de crédito",
    inv_detail_admin_ok: "Acción aplicada",
    inv_detail_admin_err: "No se pudo aplicar la acción",
    inv_detail_wo_not_found: "Work Order no encontrada en el taller",
    inv_detail_wo_open_err: "No se pudo abrir la Work Order",
    inv_detail_wo_created: "Work Order creada: {n}",
    inv_detail_wo_existed: "Work Order {n} — abriendo…",
    inv_detail_wo_create_err: "No se pudo crear la Work Order",
    inv_detail_pdf_err: "No se pudo generar el PDF",
    inv_detail_print_err: "No se pudo imprimir",
    inv_detail_email_ok: "Email registrado (envío pendiente hasta configurar Resend)",
    inv_detail_email_err: "No se pudo registrar el email",
    inv_detail_cn_pdf_err: "No se pudo generar el PDF de la CN",
    inv_detail_label: "INV / DETAIL",
    inv_detail_origin_label: "Origen:",
    inv_detail_add_payment_btn: "+ Registrar pago",
    inv_detail_wo_link_btn: "✓ WO {n}",
    inv_detail_create_wo_btn: "→ Crear Work Order",
    inv_detail_issue_cn_btn: "Emitir Nota de Crédito",
    inv_detail_dod_btn: "⚑ Pago c/entrega",
    inv_detail_dod_prompt: "Motivo para autorizar producción sin pago (Due on Delivery):",
    inv_detail_cancel_confirm: "¿Cancelar esta factura? Solo admin puede revertir.",
    inv_detail_reactivate_prompt: "Motivo de reactivación:",
    inv_detail_sc_banner_title: "STORE CREDIT DISPONIBLE",
    inv_detail_sc_banner_msg_a: "Este cliente tiene ",
    inv_detail_sc_banner_msg_b: " en saldo a favor.",
    inv_detail_sc_apply_btn: "Aplicar al balance",
    inv_detail_sc_apply_notes: "Aplicación de Store Credit",
    inv_detail_pay_form_amount: "MONTO",
    inv_detail_pay_form_method: "MÉTODO",
    inv_detail_pay_form_date: "FECHA",
    inv_detail_pay_form_notes: "NOTAS",
    inv_detail_pay_form_method_placeholder: "— Seleccionar —",
    inv_detail_pay_form_notes_placeholder: "Opcional",
    inv_detail_pay_form_submit: "Guardar pago",
    inv_detail_cn_form_settlement: "TIPO DE LIQUIDACIÓN",
    inv_detail_cn_form_refund: "Reembolso",
    inv_detail_cn_form_sc: "Store Credit",
    inv_detail_cn_form_hint_sc: "Se abonará al saldo del cliente para futuras compras.",
    inv_detail_cn_form_hint_refund: "Se registra la devolución de dinero (efectivo, tarjeta, cheque, etc.).",
    inv_detail_cn_form_amount: "MONTO",
    inv_detail_cn_form_method: "MÉTODO DE REEMBOLSO (opcional)",
    inv_detail_cn_form_method_none: "— (Ninguno) —",
    inv_detail_cn_form_reason: "MOTIVO",
    inv_detail_cn_form_reason_placeholder: "Ej: Ajuste por daño",
    inv_detail_cn_form_submit: "Emitir CN",
    inv_detail_section_items: "Ítems (snapshot inmutable)",
    inv_detail_section_payments: "Pagos registrados ({n})",
    inv_detail_section_cns: "Notas de crédito ({n})",
    inv_detail_section_customer_notes: "Notas al cliente",
    inv_detail_meta_paid: "Pagada:",
    inv_detail_meta_cancelled: "Cancelada:",
    inv_detail_no_payments: "Aún no hay pagos.",
    inv_detail_no_cns: "Sin notas de crédito.",
    inv_detail_payment_recorded_by: "registrado por {name}",
    inv_detail_summary_payments_received: "Pagos recibidos",
    inv_detail_summary_credit_notes: "Credit Notes",
    inv_detail_summary_balance: "BALANCE",

    // ─── Credit Notes Panel ───
    cn_panel_title: "Notas de crédito",
    cn_panel_subtitle: "{n} nota{s} · reducen el balance de la factura origen.",
    cn_panel_load_err: "No se pudieron cargar las notas de crédito",
    cn_panel_pdf_err: "No se pudo generar el PDF",
    cn_panel_empty: "No hay notas de crédito emitidas todavía.",
    cn_panel_col_invoice: "Factura",
    cn_panel_col_client: "Cliente",
    cn_panel_col_reason: "Motivo",
    cn_panel_col_method: "Método",
    cn_panel_col_date: "Fecha",
    cn_panel_col_amount: "Monto",

    // ─── Work Orders Panel ───
    wo_panel_title: "Work Orders",
    wo_panel_subtitle: "{o} orden{eso} · {p} pieza{sp} en producción.",
    wo_panel_load_err: "No se pudieron cargar las Work Orders",
    wo_panel_open_err: "No se pudo abrir la Work Order",
    wo_panel_pdf_err: "No se pudo generar el PDF",
    wo_panel_search_placeholder: "Buscar por WO#, cliente, INV origen…",
    wo_panel_empty: "No hay Work Orders todavía. Cree una desde una Invoice.",
    wo_panel_col_wo: "WO #",
    wo_panel_col_origin: "Origen (Invoice)",
    wo_panel_col_client: "Cliente",
    wo_panel_col_contact: "Contacto",
    wo_panel_col_delivery: "Entrega",
    wo_panel_col_pieces: "Piezas",
    wo_panel_col_status: "Estado",

    // ─── Customers Panel ───
    cust_panel_title: "Clientes",
    cust_panel_subtitle: "Se crean automáticamente al guardar cotizaciones. Nunca duplicamos.",
    cust_panel_new_btn: "+ Nuevo cliente",
    cust_panel_search_placeholder: "Buscar por empresa, contacto, teléfono, email…",
    cust_panel_load_err: "No se pudieron cargar los clientes",
    cust_panel_empty: "Sin resultados.",
    cust_panel_none_selected: "Selecciona un cliente para ver su perfil.",
    cust_profile_load_err: "No se pudo cargar el perfil",
    cust_profile_updated_ok: "Cliente actualizado",
    cust_profile_save_err: "Error al guardar",
    cust_profile_label: "PERFIL",
    cust_profile_edit_btn: "✎ Editar",
    cust_profile_contact: "Contacto",
    cust_profile_phone: "Teléfono",
    cust_profile_email: "Email",
    cust_profile_store_credit: "Store Credit",
    cust_profile_notes: "Notas",
    cust_profile_notes_lower: "notas",
    cust_profile_history_title: "HISTORIAL DE COTIZACIONES",
    cust_profile_history_empty: "Sin cotizaciones aún.",
    cust_profile_files_title: "ARCHIVOS DEL CLIENTE",
    cust_profile_files_empty: "Sin archivos del cliente.",
    cust_profile_files_download: "Descargar",
    cust_profile_files_view: "Ver",
    file_preview_print: "Imprimir",
    file_preview_download: "Descargar",
    file_preview_close: "Cerrar",
    file_preview_load_err: "No se pudo cargar la vista previa.",
    cust_profile_files_download_err: "No se pudo descargar el archivo.",
    est_form_item_note_ph: "Nota del producto (ej: logo bordado, color de hilo…)",
    task_product_note: "Nota del producto",
    cust_profile_sc_history_title: "HISTORIAL DE STORE CREDIT",
    cust_profile_sc_applied: "APLICADO",
    cust_profile_sc_issued: "EMITIDO",
    cust_new_title: "Nuevo cliente",
    cust_new_company_required: "Empresa es obligatoria",
    cust_new_create_err: "Error al crear",
    cust_new_notes_placeholder: "Notas",
    cust_new_creating: "Guardando…",
    cust_new_create_btn: "Crear",

    // ─── Payments Section (Order modal) ───
    pay_amount_invalid: "Monto inválido",
    pay_ok: "Pago registrado",
    pay_delete_confirm: "¿Eliminar este pago?",
    pay_deleted_ok: "Pago eliminado",
    pay_kpi_total: "TOTAL",
    pay_kpi_deposit_plus: "DEPÓSITO + PAGOS",
    pay_kpi_pending: "PENDIENTE",
    pay_none: "Aún no hay pagos adicionales",
    pay_field_amount: "Monto",
    pay_field_method: "Método",
    pay_field_note: "Nota",
    pay_add_btn: "+ Registrar pago",

    // ─── Company Info Panel ───
    co_load_err: "No se pudo cargar la configuración",
    co_saved_ok: "Configuración guardada",
    co_save_err: "Error al guardar",
    co_loading: "Cargando configuración…",
    co_back: "← Volver",
    co_title: "Información de la Empresa",
    co_subtitle: "Datos usados en Estimates, Invoices y Credit Notes (encabezado y footer).",
    co_section_general: "DATOS GENERALES",
    co_field_name: "Nombre de la empresa",
    co_field_logo_url: "URL del logo (PNG/JPG)",
    co_field_website: "Website",
    co_field_email: "Email de la empresa (usado en PDF y Resend)",
    co_field_phone: "Teléfono principal",
    co_field_validity: "Validez del Estimate (días)",
    co_section_offices: "OFICINAS",
    co_add_office: "+ Agregar oficina",
    co_office_key: "Key (identificador)",
    co_office_name: "Nombre visible",
    co_office_address: "Dirección",
    co_office_phone: "Teléfono",
    co_office_email: "Email",
    co_office_remove: "Eliminar oficina",
    co_section_footers: "FOOTERS Y AVISOS DE DOCUMENTOS",
    co_field_prod_notice: "Aviso de producción (impreso en Estimates)",
    co_field_est_footer: "Footer del Estimate (una línea por renglón)",
    co_field_inv_footer: "Footer de Invoices (una línea por renglón)",
    co_field_inv_footer_placeholder: "Gracias por su compra.\nLos pagos pendientes deben liquidarse dentro de los términos acordados.\nConserve este documento para sus registros.",
    co_field_cn_footer: "Footer de Credit Notes (una línea por renglón)",
    co_field_cn_footer_placeholder: "Esta nota de crédito ajusta la factura de origen indicada arriba.\nConserve este documento para sus registros.",
    co_field_pay_methods: "Métodos de pago aceptados (separados por coma)",
    co_field_whatsapp_tpl: "Plantilla de WhatsApp",
    co_wa_placeholders_hint: "Placeholders disponibles:",
    co_save_btn: "Guardar cambios",

    // ─── GP 1.0 · Sprint D · Fase 2 (i18n coverage: Dashboard tabs +
    //     OrderDetailsModal actions + CustomProductEditor) ───
    action_mark_delivered: "✓ Marcar como entregado",
    sku_optional_label: "SKU (opcional)",
    custom_product_new_title: "Nuevo producto personalizado",
    custom_product_edit_title: "Editar producto personalizado",
    custom_product_subtitle: "Ítem manual — no proviene del catálogo. Los campos con * son obligatorios.",
    custom_product_item_label: "ITEM / CUSTOM",
    custom_product_description_label: "Descripción (se imprime en el PDF)",
    custom_product_artwork_label: "URL del arte / arte del cliente",
    field_decoration_section: "Decoración",
    field_method: "Método",
    field_taxable_option: "Taxable",
    field_exempt_option: "Exempt",
    custom_product_add_to_estimate: "Agregar al Estimate",
    custom_product_name_required: "El nombre del producto es obligatorio",
    custom_product_placeholder_name: "Ej: Playera negra premium",
    custom_product_placeholder_description: "Ej: Playera 100% algodón, talla M, cuello redondo…",
    custom_product_placeholder_method: "DTF, Screen, Bordado, Vinil…",
    custom_product_placeholder_position: "Ej: Front Chest 4x4",
    custom_product_placeholder_colors: "Ej: Rojo, Negro, Blanco",

    // ─── GP 1.0 · Sprint E · Centro de Alertas de Producción ───
    alert_center_title: "Alertas de producción",
    alert_center_empty: "Sin alertas pendientes",
    alert_center_loading: "Cargando alertas…",
    alert_invoice_missing_wo_title: "Invoice sin Work Order",
    alert_time_just_now: "justo ahora",
    alert_time_minutes: "hace {n} min",
    alert_time_hours: "hace {n} h",
    alert_time_days: "hace {n} d",
    alert_bell_tooltip: "Alertas de producción",

    // Bloque 4 — Comisiones Partner Points
    tab_commissions: "Comisiones",
    comm_title_mine: "Mis comisiones",
    comm_title_admin: "Comisiones por Partner",
    comm_subtitle: "Se reconocen en el mes en que se completa el pago · liquidación los días 1–5 del mes siguiente",
    comm_rate_line: "Comisión directa",
    comm_rate_suffix: "sobre ventas pagadas, sin impuestos",
    comm_total: "Total acumulado",
    comm_period_total: "Total del período",
    comm_empty: "Aún no hay ventas pagadas elegibles.",
    comm_no_partners: "Sin Partner Points registrados.",
    comm_from: "Desde",
    comm_to: "Hasta",
    comm_filter: "Filtrar",
    comm_clear: "Limpiar",
    comm_pdf: "Descargar PDF",
    comm_pdf_error: "No se pudo generar el PDF",
    comm_col_invoice: "Factura",
    comm_col_client: "Cliente",
    comm_col_issued: "Emitida",
    comm_col_paid: "Pagada",
    comm_col_base: "Base",
    comm_col_commission: "Comisión",
    comm_status_pending: "Pendiente",
    comm_status_settled: "Liquidada",
    comm_status_paid: "Pagada",
    comm_settle: "Liquidar mes",
    comm_mark_paid: "Marcar pagada",
    comm_net: "Neto",
    comm_adj_from: "Ajuste de",
    comm_settled_ok: "Mes liquidado correctamente",
    comm_paid_ok: "Liquidación marcada como pagada",
    comm_settle_error: "No se pudo completar la operación",
    comm_error: "No se pudieron cargar las comisiones",
    comm_select_partner: "Partner",
    comm_all_partners: "Todos los Partners",
    comm_pay_title: "Registrar pago de liquidación",
    comm_pay_note: "Solo registra un pago ya efectuado fuera de GP. No se puede modificar después.",
    comm_pay_date: "Fecha real de pago",
    comm_pay_method: "Método",
    comm_method_check: "Cheque",
    comm_check_number: "Número de cheque",
    comm_zelle_ref: "Referencia Zelle (opcional)",
    comm_pay_amount: "Importe pagado",
    comm_pay_confirm: "Confirmar pago",
    comm_cancel: "Cancelar",
    comm_paid_via: "Pagada vía",
    comm_registered_by: "registró",
    comm_inv_cancelled: "Cancelada",
    comm_inv_credited: "Acreditada",

    // Bloque 5A — Traslado y entrega Partner Point
    pd_title: "Entrega Partner Point",
    pd_step_sent: "Enviado al Partner",
    pd_step_received: "Recibido en el establecimiento",
    pd_step_delivered: "Entregado al cliente",
    pd_mark_sent_btn: "Marcar enviado al Partner",
    pd_resend_btn: "Re-enviar (regenera PIN)",
    pd_pin_note_admin: "El PIN de entrega solo es visible para el cliente en su factura pública.",
    pd_confirm_received_btn: "Confirmar recepción",
    pd_pin_label: "PIN del cliente",
    pd_deliver_btn: "Entregar pedido",
    pd_attempts_left: "Intentos restantes:",
    pd_pin_locked: "PIN bloqueado — contacta a Rawen's",
    pd_delivered_msg: "Pedido entregado al cliente",
    pd_ok: "Operación registrada",
    pd_error: "No se pudo completar la operación",
  },
  en: {
    app_title: "GP by Rawen's",
    app_subtitle: "Order & Task Management",
    login_title: "GP by Rawen's",
    login_subtitle: "Order & Task Management",
    email: "Email",
    email_or_username: "Email or Username",
    username: "Username",
    password: "Password",
    name: "Name",
    enter: "Sign in",
    logout: "Logout",
    leave_blank_to_keep: "Leave blank to keep current",

    tab_dashboard: "Dashboard",
    tab_insights: "Universal Dashboard",
    tab_orders: "Orders",
    tab_tasks: "Tasks",
    tab_calendar: "Calendar",
    tab_employees: "Employees",
    tab_order_history: "History",

    // Sprint O1 — Production board (item-centric)
    tab_production: "Production",
    production_title: "Production Queue",
    production_subtitle: "Every product, its status, owner and blockers — in one view",
    production_empty: "No products match the current filters",
    production_filter_blocker: "Blocker",
    production_filter_status: "Status",
    production_filter_employee: "Owner",
    production_filter_method: "Method",
    production_filter_all: "All",
    production_filter_reset: "Clear filters",
    production_open_order: "Open order",
    production_assignee_unassigned: "Unassigned",
    production_blocker_missing_art: "Art missing",
    production_blocker_missing_payment: "Payment missing",
    production_blocker_missing_material: "Material missing",
    production_blocker_missing_approval: "Approval missing",
    production_blocker_art: "Art approved",
    production_blocker_payment: "Payment received",
    production_blocker_material: "Material received",
    production_blocker_approval: "Customer approved",
    production_status_pending: "Pending",
    production_status_design: "Design",
    production_status_ready_for_production: "Ready to produce",
    production_status_in_production: "In production",
    production_status_ready_for_delivery: "Ready to deliver",
    production_status_delivered: "Delivered",
    production_count: "{n} items in queue",

    dashboard_title: "Production Dashboard",
    dashboard_subtitle: "Live metrics · orders sorted by nearest delivery date",
    kpi_overdue: "Overdue Orders",
    kpi_today: "Due Today",
    kpi_week: "Due This Week",
    kpi_total: "Total Open Orders",
    kpi_open_orders: "Open Orders",
    kpi_deliveries_today: "Deliveries Today",
    kpi_deliveries_week: "Deliveries This Week",
    kpi_total_pending: "Pending to Collect",
    kpi_total_collected: "Total Collected",
    kpi_section_operational: "Operational",
    kpi_section_financial: "Financial",

    new_order: "New order",
    edit_order: "Edit order",
    invoice_number: "Invoice Number",
    company_name: "Company Name",
    customer: "Customer",
    customer_phone: "Customer Phone",
    product: "Product",
    delivery_date: "Delivery Date",
    days_remaining_label: "Days Remaining",
    notes: "Notes",
    status: "Status",
    total_amount: "Total Amount",
    deposit_received: "Deposit Received",
    pending_balance: "Pending Balance",
    download_pdf: "Download PDF",
    production_order: "Production Order",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    no_orders: "No orders yet. Create the first one.",

    order_status_design: "Design",
    order_status_waiting_approval: "Waiting for Approval",
    order_status_production: "Production",
    order_status_ready: "Ready for Pickup/Delivery",
    order_status_delivered: "Delivered",

    overdue_by: (n) => `Overdue by ${n} ${n === 1 ? "day" : "days"}`,
    due_today: "Due Today",
    due_tomorrow: "Due Tomorrow",
    days_remaining: (n) => `${n} ${n === 1 ? "day" : "days"} remaining`,

    new_task: "New task",
    edit_task: "Edit task",
    task_name: "Task name",
    assigned_to: "Assigned to",
    due_date: "Due date",
    mark_completed: "Mark Completed",
    completed: "Completed",
    no_tasks: "No tasks assigned yet.",
    filter_employee: "Employee",
    filter_status: "Status",
    filter_due: "Due",
    all: "All",
    unassigned: "Unassigned",
    none: "None",
    pending: "Pending",
    today: "Today",
    this_week: "This week",
    overdue: "Overdue",
    upcoming: "Upcoming",
    related_order: "Order / Company",
    task_status_pending: "Pending",
    task_status_in_progress: "In progress",
    task_status_completed: "Completed",

    new_employee: "New employee",
    edit_employee: "Edit employee",
    role: "Role",
    no_employees: "No employees yet.",

    confirm_delete: "Are you sure you want to delete?",
    welcome: "Welcome",
    my_tasks: "My Tasks",
    orders_dashboard: "Open Orders",
    sorted_by_delivery: "Sorted by delivery proximity",
    error_generic: "Something went wrong. Please try again.",
    admin: "Administrator",
    worker: "Employee",
    no_filtered_tasks: "No tasks match the filters.",

    // Phase 3 — Items / Contact / Details / History / Calendar
    contact_person: "Contact Person",
    items: "Products",
    item: "Product",
    add_item: "+ Add Product",
    remove_item: "Remove",
    product_code: "Code",
    description: "Description",
    quantity: "Quantity",
    item_notes: "Notes",
    view_details: "View Details",
    order_details: "Order Details",
    customer_info: "Customer Info",
    financial_info: "Financial Info",
    products_list: "Products List",
    related_tasks: "Related Tasks",
    no_related_tasks: "No related tasks",
    create_task_for_item: "+ Create task for this product",
    general_order_tasks: "General order tasks",
    item_tasks_label: "Product tasks",
    no_item_tasks: "No tasks for this product yet",
    locked_product_hint: "Product locked (inherited from order item)",
    close: "Close",
    order_history: "Order History",
    search: "Search",
    search_placeholder: "Search by customer, company, contact, phone or invoice...",
    search_orders_placeholder: "Search by company, customer, invoice, order # or phone...",
    search_tasks_placeholder: "Search by company, customer, order #, task name or phone...",
    no_history_results: "No delivered orders found",
    active_orders: "Active Orders",
    section_active: "Active",
    section_history: "Delivered",

    // Calendar
    calendar_title: "Workload Calendar",
    calendar_subtitle: "Monthly view of tasks per employee · drag to reschedule",
    prev_month: "Previous month",
    next_month: "Next month",
    today_btn: "Today",
    legend_overdue: "Overdue",
    legend_unassigned: "Unassigned",
    drop_to_reschedule: "Drop to reschedule",
    reschedule_success: "Task rescheduled",
    task_description: "Task Description",

    // Task Details Modal
    task_details: "Task Details",
    open_order: "Open Order",
    no_order_linked: "No linked order",

    // Invoice PDF attachment
    import_invoice_pdf: "Import Invoice PDF",
    invoice_pdf_save_first: "Save the order first to attach a PDF",
    invoice_pdf_uploaded: "Invoice PDF uploaded",
    invoice_pdf_deleted: "PDF removed",
    invoice_pdf_attached: "PDF Attached",
    invoice_pdf_view: "View PDF",
    invoice_pdf_replace: "Replace PDF",
    invoice_pdf_remove: "Remove PDF",
    invoice_pdf_invalid: "Please select a valid PDF file",
    invoice_pdf_uploading: "Uploading PDF...",
    invoice_pdf_none: "No PDF attached yet",
    invoice_pdf_select: "Select PDF",
    invoice_pdf_drop_hint: "Click to choose or drop the PDF here",
    invoice_pdf_uploaded_at: "Uploaded",

    // Task Priority
    priority: "Priority",
    priority_normal: "Normal",
    priority_priority: "Priority",
    priority_urgent: "Urgent",

    // Task Type (additive — categorization for reports)
    task_type: "Task type",
    task_type_placeholder: "Select a type",
    task_type_other_placeholder: "Describe the task type",

    // Settings (Sprint 1 — Financial Configuration)
    tab_settings: "Settings",
    settings_title: "Settings",
    settings_subtitle: "System administration modules",
    settings_financial_card_title: "Financial Configuration",
    settings_financial_card_desc: "Manage categories and products with average cost",
    settings_product_types_card_title: "Product Types",
    settings_product_types_card_desc: "Define the base types products will have",
    settings_catalogs_card_title: "Master Catalogs",
    settings_catalogs_card_desc: "Brands, suppliers, sizes, colors, materials, decoration methods, logo locations and more",
    settings_card_coming_soon: "Coming soon",
    catalogs_hub_title: "Master Catalogs",
    catalogs_hub_subtitle: "Reusable ERP foundation · add entries any time",
    cat_brands_title: "Brands",
    cat_suppliers_title: "Suppliers",
    cat_item_types_title: "Item Types",
    cat_uom_title: "Units of Measure",
    cat_sizes_title: "Sizes",
    cat_colors_title: "Colors",
    cat_decoration_methods_title: "Decoration Methods",
    cat_logo_locations_title: "Logo Locations",
    cat_materials_title: "Materials",
    // Smart Products (Product Catalog) — V2 additive
    settings_smart_products_card_title: "Product Catalog",
    settings_smart_products_card_desc: "Smart products that define which fields GP asks on each order",
    // Phase-1 Add Product architecture (Catalog · Custom · Service)
    add_item_picker_title: "Add product to order",
    add_item_picker_subtitle: "Pick where this item comes from. These 3 options are GP's new permanent architecture.",
    add_item_picker_select: "Select",
    add_item_from_catalog_title: "Apparel & Uniforms",
    add_item_from_catalog_desc: "T-Shirts, polos, caps, bags and more — with ready SKU, colors and sizes.",
    add_item_custom_catalog_title: "Custom Products",
    add_item_custom_catalog_desc: "Browse GP's internal catalog of custom products.",
    add_item_manual_title: "Manual Product",
    tab_finance: "Finance",
    fin_title: "Reports & Accounting",
    fin_subtitle: "Rawen's financial overview",
    fin_period_today: "Today",
    fin_period_week: "This week",
    fin_period_month: "This month",
    fin_period_year: "This year",
    fin_period_custom: "Custom",
    fin_apply: "Apply",
    fin_loading: "Loading financial data…",
    fin_empty: "No results for this period.",
    fin_err_server: "Server error while loading financial data",
    fin_err_forbidden: "You are not authorized to view this information",
    fin_kpi_invoiced: "Invoiced Sales",
    fin_kpi_collected: "Money Collected",
    fin_kpi_receivables: "Receivables",
    fin_kpi_costs: "Recorded Costs",
    fin_kpi_gross: "Gross Profit",
    fin_kpi_margin: "Gross Margin",
    fin_kpi_coverage: "Cost Coverage",
    fin_estimated: "estimated",
    fin_warn_title: "Estimated profit",
    fin_warn_body: "some lines have no recorded costs. Profit may be overestimated.",
    fin_costs_complete: "Costs complete for the selected period.",
    fin_details: "Period Details",
    fin_invoice_count: "Invoices included",
    fin_no_lines: "There are no line items to evaluate costs for this period.",
    fin_vs_prev: "vs previous period",
    fin_vs_yoy: "vs same period last year",
    fin_new: "New",
    fin_no_change: "No change",
    fin_donut_title: "Collected vs. Receivables",
    fin_donut_empty: "No collections or outstanding balances to display.",
    fin_trend_title: "Period Trend",
    fin_trend_empty: "No data to chart for this period.",
    fin_total: "Total",
    fin_receivables_note: "Current balance — no historical comparison",
    fin_ar_title: "Accounts Receivable",
    fin_ar_loading: "Loading accounts receivable…",
    fin_ar_empty: "No invoices pending collection.",
    fin_ar_total: "Total Outstanding",
    fin_ar_not_due: "Not due yet",
    fin_ar_due_today: "Due today",
    fin_ar_b_1_7: "1–7 days overdue",
    fin_ar_b_8_30: "8–30 days overdue",
    fin_ar_b_30: "30+ days overdue",
    fin_ar_no_date: "No due date",
    fin_ar_days: "days",
    fin_ar_col_number: "Invoice",
    fin_ar_col_customer: "Customer",
    fin_ar_col_phone: "Phone",
    fin_ar_col_invoice_date: "Invoice Date",
    fin_ar_col_delivery: "Delivery",
    fin_ar_col_total: "Total",
    fin_ar_col_paid: "Paid",
    fin_ar_col_balance: "Balance",
    fin_ar_col_status: "Status",
    fin_ar_col_aging: "Aging",
    fin_ar_st_unpaid: "Unpaid",
    fin_ar_st_partial_paid: "Partial paid",
    fin_ar_st_due_on_delivery: "Due on delivery",
    fin_bi_title: "Import bank expenses (Bank of America)",
    fin_bi_upload: "Upload bank CSV",
    fin_bi_loading: "Processing…",
    fin_bi_error: "Failed to process the file",
    fin_bi_imported: "Imported",
    fin_bi_skipped: "Duplicates skipped",
    fin_bi_rejected: "Rejected",
    fin_bi_confirm: "Confirm & save",
    fin_bi_dup: "Duplicate",
    fin_bi_sum_expenses: "Selected expenses",
    fin_bi_sum_refunds: "Refunds",
    fin_bi_sum_net: "Net expense",
    fin_bi_sum_excluded: "Excluded",
    fin_bi_sum_dups: "Duplicates",
    fin_bi_sum_rows: "Transactions",
    fin_bi_col_date: "Date",
    fin_bi_col_desc: "Description",
    fin_bi_col_amount: "Amount",
    fin_bi_col_type: "Type",
    fin_bi_col_category: "Category",
    fin_bi_col_dup: "Status",
    fin_bi_t_gasto: "Expense",
    fin_bi_t_reembolso_gasto: "Expense refund",
    fin_bi_t_transferencia_no_contabilizar: "Transfer / do not count",
    fin_bi_t_deposito_no_contabilizar: "Deposit / do not count",
    fin_bi_c_materiales: "Materials",
    fin_bi_c_publicidad: "Advertising",
    fin_bi_c_software_suscripciones: "Software/Subscriptions",
    fin_bi_c_servicios: "Utilities/Services",
    fin_bi_c_renta: "Rent",
    fin_bi_c_nomina: "Payroll",
    fin_bi_c_impuestos: "Taxes",
    fin_bi_c_transporte: "Transportation",
    fin_bi_c_comisiones_bancarias: "Bank fees",
    fin_bi_c_sales_tax_remitido: "Sales tax remitted",
    fin_bi_c_otros: "Other",
    fin_kpi_sales_pretax: "Sales before tax",
    fin_kpi_tax_invoiced: "Sales tax invoiced",
    fin_kpi_total_with_tax: "Total invoiced with tax",
    fin_kpi_exempt: "Tax-exempt sales",
    fin_kpi_gross_pretax: "Provisional gross profit (before tax)",
    fin_kpi_margin_pretax: "Provisional gross margin (before tax)",
    fin_collected_note: "Includes sales tax",
    fin_ex_tax_remitted: "Sales tax remitted",
    fin_bi_new_cat: "+ Create new category",
    fin_bi_new_cat_title: "New category",
    fin_bi_create: "Create",
    fin_bi_cancel: "Cancel",
    fin_bi_manage_cats: "Manage categories",
    fin_bi_custom_cats: "Custom categories",
    fin_bi_deactivate: "Deactivate",
    fin_bi_activate: "Activate",
    fin_bt_title: "Imported bank transactions",
    fin_bt_empty: "No imported bank transactions.",
    fin_bt_type_all: "All types",
    fin_bt_cat_all: "All categories",
    fin_bt_search: "Search description…",
    fin_bt_col_file: "File",
    fin_bt_col_imported_at: "Imported on",
    fin_bt_col_imported_by: "Imported by",
    fin_bt_col_status: "Status",
    fin_bt_status_all: "All statuses",
    fin_bt_status_active: "Active",
    fin_bt_status_voided: "Voided",
    fin_bt_batches_title: "Import batches",
    fin_bt_void: "Void batch",
    fin_bt_reactivate: "Reactivate batch",
    fin_bt_void_confirm: "Void this batch? Its transactions will be marked as voided and excluded from future calculations. No records are deleted.",
    fin_bt_react_confirm: "Reactivate this batch? Its transactions will become active again.",
    fin_ex_title: "Bank expenses & period result",
    fin_ex_gross: "Gross bank expenses",
    fin_ex_refunds: "Refunds",
    fin_ex_net: "Net bank expense",
    fin_ex_count: "Counted transactions",
    fin_ex_materials: "Materials paid",
    fin_ex_equipment: "Equipment/Machinery paid",
    fin_ex_operating: "Operating expenses",
    fin_ex_cashflow: "Net cash flow",
    fin_ex_result: "Estimated operating result",
    fin_ex_cashflow_note: "Cash flow: compares payments recorded in GP with classified bank outflows. It does not represent accounting profit.",
    fin_ex_excluded_note: "Materials and Equipment/Machinery count toward cash flow, but not toward the estimated operating result (avoids double-counting production costs and financed principal).",
    fin_ex_overstated: "This result may be overstated because some invoice lines have no recorded cost.",
    fin_ex_disclaimer: "This calculation combines invoiced sales, known production costs and classified bank expenses. It does not replace a financial statement prepared by an accountant.",
    fin_ex_by_category: "Net expense by category",
    fin_ex_trend: "Net bank expense trend",
    fin_ex_empty: "No bank transactions in this period.",
    fin_dl_pdf: "Download PDF",
    fin_dl_xlsx: "Download Excel",
    fin_payment_count: "Payments included",
    fin_total_lines: "Total lines",
    fin_lines_with_cost: "Lines with cost",
    fin_lines_missing_cost: "Lines without cost",
    fin_pending_cost_alert: "There are {n} products with pending cost. Profit may be overestimated.",
    fin_review_invoices: "Review invoices",
    inv_filter_pending_cost: "Pending cost",
    inv_cost_section: "Costs (Admin only)",
    inv_cost_pending: "Pending cost",
    inv_cost_recorded: "Cost recorded",
    inv_cost_unit: "Cost per unit",
    inv_cost_confirm_zero: "Confirm real cost of $0",
    inv_cost_save: "Save cost",
    inv_cost_saved: "Cost saved",
    inv_cost_save_err: "Could not save the cost",
    inv_cost_confirm_zero_hint: "Check the box to confirm a real cost of $0.",
    rc_tab_summary: "Summary",
    rc_tab_receipts: "Receipts",
    rc_add: "Add receipt",
    rc_new_title: "New receipt",
    rc_edit_title: "Edit receipt",
    rc_date: "Receipt date",
    rc_vendor: "Merchant / Vendor",
    rc_amount: "Amount",
    rc_category: "Category",
    rc_office: "Branch",
    rc_office_none: "— No branch —",
    rc_file: "Receipt file (JPG, PNG or PDF)",
    rc_file_replace: "Replace file (optional)",
    rc_current_file: "Current file",
    rc_save: "SAVE RECEIPT",
    rc_saved: "Receipt saved",
    rc_updated: "Receipt updated",
    rc_deleted: "Receipt deleted",
    rc_err: "Error saving the receipt",
    rc_load_err: "Could not load receipts",
    rc_delete_err: "Could not delete the receipt",
    rc_file_err: "Could not open the file",
    rc_required: "Complete the required fields (date, merchant, amount, category and file)",
    rc_search: "Search by merchant, amount or date…",
    rc_filters: "Filters",
    rc_year: "Year",
    rc_month: "Month",
    rc_all: "All",
    rc_view: "View",
    rc_download: "Download",
    rc_print: "Print",
    rc_edit: "Edit",
    rc_delete: "Delete",
    rc_confirm_delete: "Are you sure you want to delete this receipt?",
    rc_empty: "No receipts yet. Tap “+ Add receipt” to save the first one.",
    add_item_manual_desc: "Add a one-off product or service without saving it to any catalog.",
    manual_item_form_title: "Manual Product",
    manual_item_form_subtitle: "This item is added to this document only. It is not saved to the catalog.",
    manual_item_description: "Description",
    manual_item_description_ph: "E.g.: Installation Service",
    manual_item_quantity: "Quantity",
    manual_item_price: "Unit Price",
    manual_item_note: "Product Note",
    manual_item_note_ph: "Note visible to the customer (optional)",
    manual_item_add: "Add Product",
    manual_item_required_desc: "Description is required",
    add_item_custom_title: "Custom Product",
    add_item_custom_desc: "Classic manual flow: set SKU, description, brand, supplier and product-specific fields.",
    add_item_service_title: "Service",
    add_item_service_desc: "Graphic design, installation, digitizing, shipping, rush order, consultation.",
    // ─ New scalable architecture (Feb 2026): two tiers ─
    add_product_button: "Add product",
    add_product_router_title: "Where is this product coming from?",
    add_product_router_subtitle: "Pick a source to add items to this order.",
    add_product_source_rawens_title: "Rawen's Inventory",
    add_product_source_rawens_desc: "Internal products, custom products and services from your own inventory.",
    add_product_source_purchasing_title: "Purchasing Center",
    add_product_source_purchasing_desc: "Official supplier catalogs (SanMar, S&S, AlphaBroder, ...).",
    add_product_back: "Change source",
    // Purchasing Center — supplier picker
    purchasing_pick_supplier_title: "Pick a supplier",
    purchasing_pick_supplier_subtitle: "Each supplier keeps its own official catalog.",
    purchasing_supplier_unavailable: "Not available yet",
    purchasing_supplier_coming_soon: "Coming soon",
    purchasing_open_catalog: "Open catalog",
    // Supplier catalog search
    supplier_catalog_title: "Supplier catalog",
    supplier_catalog_search_placeholder: "Search by SKU, style, brand or keyword...",
    supplier_catalog_filter_brand: "Brand",
    supplier_catalog_filter_category: "Category",
    supplier_catalog_all: "All",
    supplier_catalog_no_results: "No results. Try other keywords or clear filters.",
    supplier_catalog_results: "results",
    supplier_catalog_starting_from: "from",
    supplier_catalog_colors: "colors",
    supplier_catalog_sizes: "sizes",
    supplier_catalog_open_product: "View product",
    // Supplier product detail
    supplier_detail_view_on_vendor: "View on vendor site",
    supplier_detail_wholesale_cost: "Wholesale cost",
    supplier_detail_msrp: "Suggested price (MSRP)",
    supplier_detail_pick_color: "Pick color",
    supplier_detail_pick_size: "Quantity per size",
    supplier_detail_your_price: "Your price",
    supplier_detail_pricing_tier: "Active pricing tier",
    supplier_detail_margin: "Margin",
    supplier_detail_pricing_rule: "Applied rule",
    supplier_detail_add_to_order: "Add to order",
    supplier_detail_qty_required: "Select at least one quantity.",
    supplier_detail_added_toast: "{n} item(s) added to the order",
    supplier_detail_no_variants: "This style has no variants loaded yet.",
    supplier_detail_pricing_ladder: "Pricing ladder",
    supplier_detail_pricing_fallback: "⚠ No pricing rule configured — using default markup.",
    supplier_detail_visual_only_hint: "Reference-only catalog — open the vendor site to buy and enter the wholesale cost manually.",
    supplier_detail_manual_cost_label: "Wholesale cost (manual)",
    // Catalog picker
    catalog_title: "Product Catalog",
    catalog_search_placeholder: "Search by SKU, brand, name or description...",
    catalog_all_categories: "All",
    catalog_section_favorites: "Rawen's Favorites",
    catalog_section_new: "New Products",
    catalog_section_bestsellers: "Best Sellers",
    catalog_results: "results",
    catalog_load_error: "Could not load the catalog",
    catalog_hero_sections_title: "FEATURED",
    catalog_categories_title: "CATEGORIES",
    catalog_products_word: "products",
    catalog_view_product_btn: "View product",
    catalog_back_to_catalog: "Back to catalog",
    catalog_no_results: "No products match this filter.",
    catalog_back: "Back",
    catalog_back_to_order: "Back to order",
    // Full dynamic catalog (Feb 2026)
    catalog_full_title: "Product Catalog",
    catalog_full_subtitle: "Browse the full catalog by category, brand or keyword",
    catalog_pane_categories: "CATEGORIES",
    catalog_pane_brands: "BRANDS",
    catalog_pane_all: "All",
    catalog_filter_brand: "Brand",
    catalog_filter_category: "Category",
    catalog_filter_subcategory: "Subcategory",
    catalog_filter_clear: "Clear filters",
    catalog_searching: "Searching…",
    catalog_of_total: "of",
    catalog_pagination_prev: "Previous",
    catalog_pagination_next: "Next",
    catalog_pagination_page: "Page",
    catalog_colors_more: "more",
    catalog_empty_state_title: "Catalog not loaded yet",
    catalog_empty_state_hint: "The engine is running the first sync. Wait a few minutes and refresh.",
    catalog_sync_ready: "Catalog ready",
    catalog_sync_running: "Syncing…",
    catalog_sync_error: "Sync error",
    catalog_admin_panel_title: "Catalog engine",
    catalog_admin_run_sync: "Run sync",
    catalog_admin_force_sync: "Force sync",
    catalog_admin_last_synced: "Last synced",
    catalog_admin_scheduled: "Daily automatic sync 03:00 America/Chicago",
    catalog_admin_products: "products",
    catalog_detail_live_pricing: "Live pricing",
    catalog_detail_live_pricing_hint: "Price and availability are fetched from the supplier in real time.",
    catalog_detail_inventory: "Available inventory",
    catalog_detail_inventory_by_warehouse: "By warehouse",
    catalog_detail_no_inventory: "No inventory available right now.",
    // Catalog detail
    catalog_detail_category: "Category",
    catalog_detail_description: "Description",
    catalog_detail_colors: "Available colors",
    catalog_detail_sizes: "Available sizes",
    catalog_detail_qty_matrix: "Quantity by color and size",
    catalog_detail_qty_per_size: "Quantity per size",
    catalog_detail_active_color_total: "Color subtotal",
    catalog_detail_select_sizes: "Select sizes and quantities",
    catalog_detail_tap_size_hint: "Tap a size to add it to the order",
    catalog_detail_gallery: "Gallery",
    catalog_detail_summary: "Summary",
    catalog_detail_decoration_method: "Decoration method",
    // ── Order Success Panel (post-save quick share actions) ──
    order_success_title: "Order created successfully",
    order_success_number: "Order",
    order_success_customer: "Customer",
    order_success_delivery: "Delivery",
    order_success_total: "Total",
    order_success_share_title: "Customer copy · Share",
    order_success_print: "Print",
    order_success_print_hint: "Press Ctrl+P / ⌘+P in the opened tab to print.",
    order_success_download_pdf: "Download PDF",
    order_success_send_email: "Send by Email",
    order_success_send_sms: "Send by SMS",
    order_success_send_whatsapp: "Send by WhatsApp",
    order_success_no_phone: "Customer has no phone number on file.",
    order_success_phone_hint: "SMS and WhatsApp require a phone number in the customer record.",
    order_success_open_full: "View / edit full order",
    catalog_detail_select_placeholder: "Select",
    done: "Done",
    catalog_detail_color: "Color",
    catalog_detail_size: "Size",
    catalog_detail_notes: "Notes",
    catalog_detail_selling_price: "Selling price",
    catalog_detail_cost: "Cost",
    catalog_detail_base_cost: "Base Cost",
    catalog_detail_logo_location: "Position",
    catalog_detail_price_placeholder_hint: "Placeholder — will be wired to real pricing in Phase 2.",
    catalog_detail_total_qty: "Total quantity",
    catalog_detail_lines_preview: "Lines to generate",
    catalog_detail_add_to_order: "Add to Order",
    catalog_detail_qty_required: "Set at least one quantity greater than 0",
    catalog_detail_added_toast: "{n} item(s) added to the order",
    // Service form
    service_form_title: "Add Service",
    service_form_type_label: "Service type",
    service_form_qty_label: "Quantity",
    service_form_price_label: "Unit price",
    service_form_cost_label: "Unit cost",
    service_form_notes_label: "Notes",
    service_form_add_btn: "Add service",
    service_form_type_required: "Pick a service type",
    service_form_qty_required: "Quantity must be greater than 0",
    service_form_added_toast: "Service added to the order",
    service_load_error: "Could not load the service list",
    // Order item badges (catalog + service items)
    order_item_from_catalog_badge: "From Catalog",
    order_item_service_badge: "Service",
    order_item_catalog_color: "Color",
    order_item_catalog_size: "Size",
    order_item_service_type: "Type",
    // Placeholder card — future automation module
    settings_automation_card_title: "Automation",
    settings_automation_card_desc: "Rules, automatic notifications and integrations with external services",
    settings_coming_soon_badge: "Coming soon",
    // Pricing Engine (2026-02-15)
    settings_pricing_card_title: "Pricing Engine",
    settings_pricing_card_desc: "Universal pricing rules — suppliers, brands, categories, quantities, customers. With live simulator.",
    pricing_title: "Universal Pricing Engine",
    pricing_subtitle: "Dynamic rules for any supplier, brand or category. Every ERP module consumes this engine.",
    pricing_new_rule: "New rule",
    pricing_no_rules: "No rules configured. Create your first rule.",
    pricing_rule_priority: "Priority",
    pricing_rule_strategy: "Strategy",
    pricing_rule_name: "Name",
    pricing_rule_default: "Default",
    pricing_rule_active: "Active",
    pricing_rule_inactive: "Inactive",
    pricing_rule_filters: "Filters",
    pricing_rule_min_profit: "Min profit ($)",
    pricing_rule_max_discount: "Max discount (%)",
    pricing_rule_notes: "Notes",
    pricing_edit: "Edit",
    pricing_delete: "Delete",
    pricing_toggle: "Enable/Disable",
    pricing_form_new_title: "New pricing rule",
    pricing_form_edit_title: "Edit pricing rule",
    pricing_form_section_basic: "Basic settings",
    pricing_form_section_strategy: "Pricing strategy",
    pricing_form_section_filters: "Applicability (filters)",
    pricing_form_section_clamps: "Profit guardrails",
    pricing_form_section_meta: "Metadata",
    pricing_form_strategy_hint_markup: "Price = cost × (1 + markup%). Simple and predictable.",
    pricing_form_strategy_hint_quantity_break: "Tiered breaks by quantity. Each tier has its own markup% or unit price.",
    pricing_form_strategy_hint_fixed_price: "Fixed price (ignores cost). Useful for services.",
    pricing_form_strategy_hint_formula: "Arithmetic expression using cost, qty, msrp. Ex: cost * 1.4 + 2",
    pricing_form_strategy_hint_passthrough: "Price = cost (sell at cost).",
    pricing_form_markup_pct: "Markup (%)",
    pricing_form_fixed_price: "Unit price ($)",
    pricing_form_formula_expr: "Expression",
    pricing_form_break_min_qty: "Min qty",
    pricing_form_break_markup: "Markup %",
    pricing_form_break_unit_price: "Unit price",
    pricing_form_break_label: "Label",
    pricing_form_break_add: "+ Add tier",
    pricing_form_break_remove: "Remove",
    pricing_form_min_profit_hint: "Minimum profit in $. If the computed price leaves less, price is raised to the floor.",
    pricing_form_max_discount_hint: "Max discount allowed vs MSRP (or pre-clamp price). Ex: 25 means never more than 25% off.",
    pricing_form_filter_hint: "All filters are OPTIONAL. Empty = matches all. More specific wins.",
    pricing_filter_connector: "Supplier / Connector",
    pricing_filter_source_type: "Source type",
    pricing_filter_brand: "Brand",
    pricing_filter_category: "Category",
    pricing_filter_style: "Style",
    pricing_filter_sku: "SKU",
    pricing_filter_color: "Color",
    pricing_filter_size: "Size",
    pricing_filter_customer_category: "Customer category",
    pricing_filter_min_quantity: "Min quantity",
    pricing_form_priority_hint: "Higher numbers win when specificity ties.",
    pricing_form_is_default_hint: "Only one rule can be default (global fallback).",
    pricing_sim_title: "Live simulator",
    pricing_sim_subtitle: "Test prices without saving. Recomputed on every change.",
    pricing_sim_result: "Result",
    pricing_sim_unit_price: "Unit price",
    pricing_sim_total: "Line total",
    pricing_sim_margin: "Margin",
    pricing_sim_rule: "Rule applied",
    pricing_sim_clamp_min_profit: "Min-profit floor active",
    pricing_sim_clamp_max_discount: "Max-discount cap active",
    pricing_sim_fallback: "Fallback (no rule matched → 40% markup)",
    pricing_sim_reset: "Clear",
    pricing_sim_cost_placeholder: "Supplier cost",
    pricing_sim_qty_placeholder: "Quantity",
    pricing_confirm_delete: "Delete this pricing rule?",
    // Attribution chip in OrderDetailsModal (2026-02-15)
    order_item_rule_label: "Rule",
    order_item_rule_unknown: "deleted rule",
    order_item_rule_manual: "Manual price",
    order_item_rule_manual_hint: "Price entered by hand — no engine rule.",
    order_item_rule_open_hint: "Open in Pricing Engine",
    order_item_rule_none: "No rule",
    // Roles & Permissions (Sprint RBAC v2)
    settings_roles_card_title: "Roles & Permissions",
    settings_roles_card_desc: "Create custom roles, assign multiple per user, and control permissions module by module",
    roles_title: "Roles & Permissions",
    roles_subtitle: "Flexible RBAC engine — multiple roles per user, per-user overrides, and seeded system roles",
    roles_new_btn: "New role",
    roles_none: "No roles yet.",
    role_badge_system: "System",
    role_badge_admin: "Administrator",
    role_perms_count: "modules with permissions",
    role_edit: "Edit",
    role_duplicate: "Duplicate",
    role_delete: "Delete",
    role_name: "Name",
    role_description: "Description",
    role_permissions: "Permissions matrix",
    role_form_admin_note: "The Administrator role always has full access. Its permissions cannot be reduced.",
    role_form_system_note: "This is a system role. You can edit its permissions and rename it, but not delete it.",
    perm_module_all: "entire module",
    role_save_ok: "Role saved",
    role_delete_confirm: "Delete this role? Users who have it assigned will lose it.",
    role_duplicated: "Role duplicated",
    // Employees — roles multi-select + overrides
    employee_roles_label: "Assigned roles",
    employee_roles_hint: "A user can have multiple roles. Their permissions are the UNION of all.",
    employee_overrides_title: "User-specific permission overrides",
    employee_overrides_hint: "Grant or revoke individual permissions without creating another role.",
    employee_overrides_none: "No overrides — permissions come solely from the roles.",
    employee_override_grant: "Grant extra",
    employee_override_revoke: "Revoke",
    employee_effective_permissions: "Effective permissions (role + override)",
    role_legacy_field: "Legacy role (free text)",
    // Permission module labels (EN)
    perm_mod_customers: "Customers",
    perm_mod_orders: "Orders",
    perm_mod_catalog: "Catalog",
    perm_mod_production: "Production",
    perm_mod_tasks: "Tasks",
    perm_mod_calendar: "Calendar",
    perm_mod_dashboard: "Dashboard",
    perm_mod_reports: "Reports",
    perm_mod_inventory: "Inventory",
    perm_mod_purchasing: "Purchasing",
    perm_mod_financial_dashboard: "Financial Dashboard",
    perm_mod_costs: "Costs",
    perm_mod_profit: "Profit",
    perm_mod_suppliers: "Suppliers",
    perm_mod_hr: "Human Resources",
    perm_mod_crm: "CRM",
    perm_mod_users: "Users",
    perm_mod_roles: "Roles",
    perm_mod_settings: "Settings",
    perm_mod_customer_copy: "Customer Copy (Print/PDF/Email/SMS/WhatsApp)",
    // Permission action labels (EN)
    perm_act_view: "View",
    perm_act_view_all: "View all",
    perm_act_estimates_all: "Manage All Estimates",
    perm_act_create: "Create",
    perm_act_edit: "Edit",
    perm_act_delete: "Delete",
    perm_act_approve: "Approve",
    perm_act_export: "Export",
    perm_act_print: "Print",
    perm_act_send: "Send",
    smart_products_title: "Product Catalog",
    smart_products_subtitle: "Define which info GP should ask when each product is added to an order",
    smart_products_new_btn: "New product",
    smart_products_empty: "No products in the catalog yet. Create the first one.",
    smart_products_search_placeholder: "Search by name or code…",
    smart_products_required_count: "active fields",
    smart_products_section_basic: "Basic information",
    smart_products_section_fields: "Required fields for this product",
    smart_products_section_fields_hint: "Enable the fields GP must ask when this product is added to an order. Min. 0 · Max. 14.",
    smart_products_orders_pending_note: "Coming soon: the Orders flow will consume this configuration to ask only the enabled fields. The integration is still pending.",
    smart_products_orders_ready_note: "Integrated: when creating an Order and picking this product, GP auto-fills SKU, name, brand, model, supplier, unit and production time, and only asks the fields enabled here.",
    smart_products_default_model: "Default model",
    smart_products_default_model_hint: "e.g. 29M, P150, etc. Inherited when creating an Order.",
    smart_products_description: "Description",
    smart_products_description_hint: "Description shown on the Order when this product is picked.",
    smart_products_production_time_unit_minutes: "Minutes",
    order_item_smart_product: "Catalog Product (Smart Product)",
    order_item_smart_product_placeholder: "— Pick a smart product —",
    order_item_inherits_label: "Inherited from product",
    order_item_no_smart_product_hint: "Pick a catalog product to auto-fill.",
    smart_products_unit_of_measure: "Unit of measure",
    smart_products_item_type: "Item type",
    smart_products_code: "Code (SKU)",
    smart_products_code_hint: "optional, unique",
    smart_products_uom: "Unit of measure",
    smart_products_default_brand: "Default brand",
    smart_products_default_supplier: "Default supplier",
    smart_products_field_brand: "Brand",
    smart_products_field_model: "Model",
    smart_products_field_color: "Color",
    smart_products_field_size: "Size",
    smart_products_field_quantity: "Quantity",
    smart_products_field_decoration_method: "Decoration method",
    smart_products_field_logo_location: "Logo location",
    smart_products_field_material: "Material",
    smart_products_field_width: "Width",
    smart_products_field_height: "Height",
    smart_products_field_thickness: "Thickness",
    smart_products_field_installation: "Installation",
    smart_products_field_led: "LED",
    smart_products_field_comments: "Comments",
    // Product Taxonomy
    tab_product_categories: "Product Categories",
    tab_product_subcategories: "Subcategories",
    smart_products_category: "Category",
    smart_products_subcategory: "Subcategory",
    smart_products_image: "Product image",
    smart_products_image_hint: "JPG / PNG / WEBP — max 8 MB",
    smart_products_image_upload: "Upload image",
    smart_products_image_remove: "Remove image",
    smart_products_image_uploading: "Uploading…",
    smart_products_production_time: "Average production time",
    smart_products_production_time_unit_hours: "Hours",
    smart_products_production_time_unit_days: "Days",
    product_taxonomy_pick_parent: "Pick a category",
    no_results: "No results",
    new_record: "New record",
    no_records: "No records yet. Create the first one.",
    name_required: "Name required",
    back: "Back",
    activate: "Activate",
    deactivate: "Deactivate",
    back_to_settings: "← Back to Settings",
    financial_config_title: "Financial Configuration",
    financial_config_subtitle: "Manage categories and products · average cost in USD",
    tab_categories: "Categories",
    tab_financial_products: "Products",
    category: "Category",
    category_name: "Category name",
    new_category: "New category",
    edit_category: "Edit category",
    no_categories: "No categories yet. Create the first one.",
    new_financial_product: "New product",
    edit_financial_product: "Edit product",
    financial_product_name: "Product name",
    average_cost: "Average Cost (USD)",
    long_description: "Description",
    long_description_hint: "Notes about materials, processes or other useful info (optional)",
    no_financial_products: "No products yet. Create the first one.",
    active: "Active",
    inactive: "Inactive",
    all_statuses: "All statuses",
    active_only: "Active only",
    inactive_only: "Inactive only",
    no_active_category_warning: "Create at least one active category before adding products",
    select_category_placeholder: "Select a category",
    cost_must_be_non_negative: "Cost cannot be negative",
    saved_ok: "Saved successfully",
    deleted_ok: "Deleted successfully",
    state_changed_ok: "Status updated",

    // Product Types (Sprint 2)
    product_types_title: "Product Types",
    product_types_subtitle: "Base type catalog · classifies system products",
    new_product_type: "New type",
    edit_product_type: "Edit type",
    product_type_name: "Type name",
    product_type_description: "Description",
    no_product_types: "No product types yet. Create the first one.",
    product_type: "Product Type",
    product_type_optional: "Product type (optional)",
    select_product_type_placeholder: "— No type —",
    type_fields_section: "Type fields",
    field_schema_section: "Custom fields",
    field_key: "Key",
    field_label: "Label",
    field_type: "Type",
    field_type_text: "Text",
    field_type_number: "Number",
    field_type_select: "List (options)",
    field_unit: "Unit",
    field_options: "Options (comma separated)",
    field_required: "Required",
    add_field: "+ Add field",
    remove_field: "Remove",
    field_key_hint: "Lowercase letters, digits and underscore only. e.g.: width, hourly_rate",

    // Sprint 4 — Catalog pricing & Order ↔ Product linkage
    sku: "Code (SKU)",
    sku_hint: "Short catalog code. e.g.: LOGO-01",
    suggested_price: "Suggested price",
    suggested_margin: "Suggested margin",
    suggested_margin_hint: "Computed: (price − cost) / price × 100",
    catalog_product_optional: "Catalog product (optional)",
    select_catalog_product: "— No product —",
    item_unit_price: "Unit price",
    item_unit_cost: "Unit cost",
    item_subtotal: "Subtotal",
    item_cost_total: "Cost",
    item_profit: "Profit",
    order_subtotal: "Subtotal",
    order_total_cost: "Total cost",
    order_total_profit: "Total profit",
    order_margin: "Margin",
    manual_item: "Manual item",

    // Sprint 5.2 — V2 Master Catalog
    v2_master_section: "Master Catalog · Attributes (optional)",
    v2_master_hint: "These attributes describe the permanent product, not the production of an order.",
    field_item_type: "Item type",
    field_brand: "Brand",
    field_supplier: "Supplier",
    field_color: "Color",
    field_size: "Size",
    field_unit_of_measure: "Unit of measure",
    field_model: "Model",
    field_requires_dimensions: "Requires dimensions (W × H)",
    field_requires_dimensions_hint: "Check this for banners, vinyls, sheet materials or anything sold by ft². Orders will auto-prompt for Width × Height × Thickness.",
    no_selection: "— Not selected —",
    legacy_product_types_notice: "Product Types (legacy): older products still work. New products should use the Master Catalog below.",

    // Sprint 5.3 — Order item structured production fields
    v2_production_section: "Production (Sprint 5.3)",
    field_decoration_method: "Decoration method",
    field_logo_location: "Logo location",
    field_colors_used: "Colors used",
    field_colors_used_hint: "e.g.: Black + White (2c), CMYK Full Color…",
    field_artwork_url: "Artwork URL",
    field_artwork_url_hint: "Link to Drive / Dropbox / design file",
    field_customer_notes: "Customer notes",
    field_width: "Width",
    field_height: "Height",
    field_thickness: "Thickness",
    field_area_sqft: "Area (ft²)",
    field_area_sqft_auto: "Auto: width × height",
    dimensions_section: "Dimensions",

    // Sprint 5.4 — CSV importer
    csv_import_button: "Import CSV",
    csv_import_title: "Import Catalog from CSV",
    csv_import_subtitle: "Create or update Master Catalog products in bulk.",
    csv_import_step_1: "1 · Download the template",
    csv_import_template_btn: "Download template",
    csv_import_template_hint: "Includes headers + 2 example rows. Use exact names for Category, Brand, Color, etc.",
    csv_import_step_2: "2 · Choose matching mode",
    csv_import_match_sku: "By SKU — update if SKU exists, otherwise create",
    csv_import_match_name: "By Name — update if name exists, otherwise create",
    csv_import_match_create_only: "Create only — reject if SKU or Name already exists",
    csv_import_step_3: "3 · Upload and validate",
    csv_import_validate_btn: "Validate file",
    csv_import_step_4: "4 · Review and execute",
    csv_import_execute_btn: "Confirm import",
    csv_import_executing: "Importing…",
    csv_import_validating: "Validating…",
    csv_import_summary_rows: "Rows",
    csv_import_summary_to_create: "To create",
    csv_import_summary_to_update: "To update",
    csv_import_summary_errors: "Errors",
    csv_import_no_errors: "No errors. Ready to import.",
    csv_import_has_errors: "Fix errors in the CSV before importing.",
    csv_import_result_created: "Created",
    csv_import_result_updated: "Updated",
    csv_import_result_skipped: "Skipped",
    csv_import_row_label: "Row",
    csv_import_action_create: "CREATE",
    csv_import_action_update: "UPDATE",
    csv_import_action_error: "ERROR",
    csv_import_close: "Close",
    csv_import_no_file: "Pick a CSV file first.",
    csv_import_success: "Import completed.",

    // Sprint 5.5 — search, filters, status, where-used
    products_search_placeholder: "Search by name, SKU or model…",
    products_filter_brand: "Brand",
    products_filter_color: "Color",
    products_filter_size: "Size",
    products_filter_supplier: "Supplier",
    products_filter_all: "All",
    products_filter_status: "Status",
    products_status_active: "Active",
    products_status_inactive: "Inactive",
    products_status_archived: "Archived",
    products_status_visible: "Active + Inactive",
    products_status_any: "Any (incl. archived)",
    products_filters_reset: "Clear filters",
    products_no_matches: "No products match the current filters.",
    product_status_label: "Status",
    status_active: "Active",
    status_inactive: "Inactive",
    status_archived: "Archived",
    archive_product: "Archive",
    archive_product_confirm: "Archive this product? It won't be selectable in new orders, but historical orders will still show it.",
    where_used_title: "Where is this product used?",
    where_used_orders_count: "orders reference this product",
    where_used_no_orders: "This product is not used in any order.",
    where_used_recent: "Recent orders",
    where_used_archive_blocked: "This product is used in {n} historical orders. Archiving will keep them readable but the product will be unavailable in new orders.",

    // ─── Sprint 7B — Commercial Docs (Estimates / Invoices / Credit Notes / Work Orders / Customers / Company Info) ───
    loading_ellipsis: "Loading…",
    saving_ellipsis: "Saving…",
    remove: "Remove",
    empty_no_events: "No events.",
    generic_ok: "OK",
    generic_error: "Error",
    filter_all_f: "All",
    filter_all_status_f: "All statuses",
    results_count: "{n} result{s}",
    action_pdf: "PDF",
    action_email_icon: "✉ Email",
    action_whatsapp: "WhatsApp",
    action_print: "🖨 Print",
    action_duplicate: "⧉ Duplicate",
    action_edit_icon: "✎ Edit",
    action_delete_icon: "🗑 Delete",
    action_cancel_icon: "✕ Cancel",
    action_reactivate_icon: "↺ Reactivate",
    action_follow_up_icon: "⏰ Follow-up",
    action_approve_icon: "✓ Approve",
    // Estimate statuses
    est_status_draft: "Draft",
    est_status_sent: "Sent",
    est_status_approved: "Approved",
    est_status_expired: "Expired",
    est_status_cancelled: "Cancelled",
    // Invoice statuses
    inv_status_unpaid: "Unpaid",
    inv_status_partial_paid: "Partially paid",
    inv_status_paid: "Paid",
    inv_status_due_on_delivery: "Due on delivery",
    inv_status_due_on_delivery_full: "Due on delivery",
    inv_status_cancelled: "Cancelled",
    inv_status_credited: "Credited",
    // Work Order statuses (Commercial view)
    wo_status_design: "In design",
    wo_status_waiting_approval: "Waiting approval",
    wo_status_production: "In production",
    wo_status_ready: "Ready",
    wo_status_delivered: "Delivered",

    // ─── Estimates Panel ───
    est_panel_title: "Estimates",
    est_panel_subtitle_all: "Full view — all estimates",
    est_panel_subtitle_mine: "Your estimates",
    est_panel_new_btn: "+ New estimate",
    est_panel_search_placeholder: "Search by number, customer, phone, email…",
    est_panel_empty: "No estimates match those filters.",
    est_panel_load_err: "Could not load estimates",
    est_panel_open_err: "Could not open the estimate",
    est_panel_pdf_err: "Could not generate the PDF",
    est_panel_dup_err: "Could not duplicate",
    est_panel_dup_ok: "Duplicated as {n}",
    est_panel_col_contact: "Contact",
    est_panel_col_office: "Office",
    est_panel_col_sales_rep: "Sales Rep",
    est_panel_col_total: "Total",
    est_panel_col_created: "Created",
    est_panel_col_expires: "Expires",
    est_panel_col_client: "Customer",
    est_panel_col_status: "Status",
    est_panel_action_duplicate_title: "Duplicate",
    est_panel_action_email_title: "Email",
    est_panel_action_wa_title: "WhatsApp",

    // ─── Estimate Form ───
    est_form_required_company: "Customer company name is required.",
    est_form_required_office: "Select an office.",
    est_form_required_items: "Add at least one product or service.",
    est_form_beanies_min: "The combined Beanies minimum is 6 (models and colors can be mixed).",
    est_form_pool_min: "The combined {pool} minimum is {min} (models and colors can be mixed).",
    add_item_vinyl_title: "Printed Vinyl",
    add_item_vinyl_desc: "Printed vinyl calculator: sizes, material, lamination, finishing and automatic paneling.",
    vinyl_calc_title: "Vinyl Calculator",
    vinyl_material: "Material",
    vinyl_size: "Size",
    vinyl_width: "Width",
    vinyl_height: "Height",
    vinyl_qty: "Quantity",
    vinyl_add_size: "+ Add Another Size",
    vinyl_remove_size: "Remove",
    vinyl_finishing: "Finishing",
    vinyl_lamination: "Lamination (laminated table)",
    vinyl_finished_area: "Finished Area",
    vinyl_production_area: "Production Area",
    vinyl_tier: "Tier",
    vinyl_paneling: "Panels",
    vinyl_panels_label: "panels",
    vinyl_no_panels: "no panels",
    vinyl_base_charge: "Vinyl charge",
    vinyl_min_applied: "$30 minimum applied",
    vinyl_total: "Total",
    vinyl_cancel: "Cancel",
    vinyl_add_to_estimate: "Add to Estimate",
    vinyl_invalid: "Check the measurements: width, height and quantity must be greater than 0.",
    add_item_banner_title: "Banner 13 oz",
    add_item_banner_desc: "Banner calculator: sizes, grommets, reinforcement, lamination and automatic paneling.",
    banner_calc_title: "Banner Calculator",
    banner_size: "Size",
    banner_width: "Width",
    banner_height: "Height",
    banner_qty: "Quantity",
    banner_add_size: "+ Add Another Size",
    banner_remove_size: "Remove",
    banner_finished_area: "Finished Area",
    banner_production_area: "Production Area",
    banner_tier: "Tier",
    banner_base_charge: "Banner charge",
    banner_min_applied: "$30 minimum applied",
    banner_total: "Total",
    banner_cancel: "Cancel",
    banner_add_to_estimate: "Add to Estimate",
    banner_invalid: "Check the measurements: width, height and quantity must be greater than 0.",
    est_form_updated_ok: "Estimate updated",
    est_form_created_ok: "Estimate created ({n})",
    est_form_save_err: "Save error",
    est_form_title_new: "New estimate",
    est_form_title_edit: "Edit estimate {n}",
    est_form_sales_rep_hint: "Sales Rep: {name} · assigned automatically.",
    est_form_field_office: "Office",
    est_form_field_delivery: "Expected delivery date",
    est_form_field_followup: "Follow-up (optional)",
    est_form_section_customer: "CUSTOMER",
    est_form_field_company: "Company *",
    est_form_field_contact: "Contact",
    est_form_field_phone: "Phone",
    est_form_field_email: "Email",
    est_form_customer_hint_title: "EXISTING CUSTOMER FOUND",
    est_form_customer_hint_apply: "Use this customer",
    est_form_section_items: "PRODUCTS / SERVICES",
    est_form_add_item: "+ Add product",
    est_form_open_catalog_btn: "📚 Catalog",
    est_form_items_empty: "No products yet. Use",
    est_form_add_item_hint_bold: "+ Add product",
    est_form_item_unnamed: "Untitled",
    est_form_item_edit_custom: "✎ Edit",
    est_form_item_remove: "Remove",
    est_form_field_discount_type: "Discount type",
    est_form_discount_amount: "Amount ($)",
    est_form_discount_percent: "Percent (%)",
    est_form_field_discount_value: "Discount value",
    est_form_field_tax: "Tax",
    est_form_tax_exempt_label: "Tax Exempt",
    est_form_field_customer_notes: "Customer notes (printed)",
    est_form_field_internal_notes: "Internal notes (never printed)",
    est_form_field_followup_notes: "Follow-up notes",
    est_form_summary_subtotal: "Subtotal",
    est_form_summary_discount: "Discount",
    est_form_summary_tax_exempt: "Tax (Exempt)",
    est_form_summary_tax_rate: "Sales Tax ({pct}%)",
    est_form_summary_total: "TOTAL",
    est_form_submit_new: "Create estimate",
    est_form_submit_edit: "Save changes",

    // ─── Estimate Detail Modal ───
    est_detail_load_err: "Could not load the estimate",
    est_detail_toast_send: "Estimate marked as Sent",
    est_detail_toast_approve: "Estimate Approved",
    est_detail_toast_cancel: "Estimate Cancelled",
    est_detail_toast_duplicate: "Duplicated as {n}",
    est_detail_action_err: "Could not perform {action}",
    est_detail_followup_ok: "Follow-up saved",
    est_detail_followup_err: "Could not save follow-up",
    est_detail_pdf_err: "Could not generate the PDF",
    est_detail_print_err: "Could not print",
    est_detail_convert_confirm: "Converting to Invoice will lock this Estimate (Duplicate only). Continue?",
    est_detail_invoice_created: "Invoice {n} created",
    est_detail_sc_prompt: "This customer has ${avail} in Store Credit. Apply ${apply} to Invoice {n} now?",
    est_detail_sc_applied: "Store Credit applied: ${amt}",
    est_detail_sc_notes: "Automatic application when converting Estimate → Invoice",
    est_detail_sc_err: "Could not apply Store Credit",
    est_detail_convert_err: "Could not convert to invoice",
    est_detail_softdelete_confirm: "Delete this Estimate? (soft-delete, admin)",
    est_detail_softdelete_ok: "Estimate deleted",
    est_detail_softdelete_err: "Could not delete",
    est_detail_label: "EST / DETAIL",
    est_detail_invoiced_badge: "INVOICED · {n}",
    est_detail_send_btn: "Mark as Sent",
    est_detail_convert_btn: "→ Convert to Invoice",
    est_detail_converting_btn: "Converting…",
    est_detail_view_invoice_btn: "View invoice {n}",
    est_detail_cancel_confirm: "Cancel this estimate?",
    est_detail_followup_date_label: "FOLLOW-UP DATE",
    est_detail_followup_notes_label: "NOTES",
    est_detail_section_customer: "Customer",
    est_detail_section_meta: "Meta",
    est_detail_section_items: "Items",
    item_group_variants_count: "{n} variants",
    item_group_variants_count_one: "1 variant",
    item_group_total_units: "{q}u",
    item_variant_label: "{color} · {size}",
    est_detail_section_customer_notes: "Customer notes (printed)",
    est_detail_section_internal_notes: "Internal notes (not printed)",
    est_detail_section_summary: "Summary",
    est_detail_section_history: "History",
    est_detail_meta_office: "Office:",
    est_detail_meta_sales_rep: "Sales Rep:",
    est_detail_meta_created: "Created:",
    est_detail_meta_expires: "Expires:",
    est_detail_meta_delivery: "Delivery:",
    est_detail_meta_followup: "Follow-up:",
    est_detail_summary_discount_pct: "Discount ({pct}%)",
    est_detail_summary_discount: "Discount",
    est_detail_summary_subtotal: "Subtotal",
    est_detail_summary_tax_exempt: "Tax (Exempt)",
    est_detail_summary_tax_rate: "Sales Tax ({pct}%)",

    // ─── Invoices Panel ───
    inv_panel_title: "Invoices",
    inv_panel_subtitle_all: "Full view — all invoices",
    inv_panel_subtitle_mine: "Your invoices",
    inv_panel_note_a: "Created only by converting an approved Estimate.",
    inv_panel_note_b: "Immutable snapshot · no direct edits.",
    inv_panel_search_placeholder: "Search by number, source EST, customer, phone…",
    inv_panel_empty: "No invoices match those filters.",
    inv_panel_load_err: "Could not load invoices",
    inv_panel_pdf_err: "Could not generate the PDF",
    inv_panel_col_invoice: "Invoice",
    inv_panel_col_origin: "Source",
    inv_panel_col_client: "Customer",
    inv_panel_col_status: "Status",
    inv_panel_col_total: "Total",
    inv_panel_col_paid: "Paid",
    inv_panel_col_balance: "Balance",
    inv_panel_col_created: "Created",

    // ─── Invoice Detail Modal ───
    inv_detail_load_err: "Could not load the invoice",
    inv_detail_pay_invalid_amount: "Enter a valid amount",
    inv_detail_pay_missing_method: "Select a payment method",
    inv_detail_pay_ok: "Payment recorded",
    inv_detail_pay_err: "Could not record the payment",
    inv_detail_cn_ok: "Credit note issued",
    inv_detail_cn_sc_ok: "Credit note issued as Store Credit",
    inv_detail_cn_err: "Could not issue the credit note",
    inv_detail_admin_ok: "Action applied",
    inv_detail_admin_err: "Could not apply the action",
    inv_detail_wo_not_found: "Work Order not found in the shop",
    inv_detail_wo_open_err: "Could not open the Work Order",
    inv_detail_wo_created: "Work Order created: {n}",
    inv_detail_wo_existed: "Work Order {n} — opening…",
    inv_detail_wo_create_err: "Could not create the Work Order",
    inv_detail_pdf_err: "Could not generate the PDF",
    inv_detail_print_err: "Could not print",
    inv_detail_email_ok: "Email recorded (delivery pending Resend configuration)",
    inv_detail_email_err: "Could not record the email",
    inv_detail_cn_pdf_err: "Could not generate the CN PDF",
    inv_detail_label: "INV / DETAIL",
    inv_detail_origin_label: "Source:",
    inv_detail_add_payment_btn: "+ Record payment",
    inv_detail_wo_link_btn: "✓ WO {n}",
    inv_detail_create_wo_btn: "→ Create Work Order",
    inv_detail_issue_cn_btn: "Issue Credit Note",
    inv_detail_dod_btn: "⚑ Due on delivery",
    inv_detail_dod_prompt: "Reason to authorize production without payment (Due on Delivery):",
    inv_detail_cancel_confirm: "Cancel this invoice? Only admins can reverse it.",
    inv_detail_reactivate_prompt: "Reactivation reason:",
    inv_detail_sc_banner_title: "STORE CREDIT AVAILABLE",
    inv_detail_sc_banner_msg_a: "This customer has ",
    inv_detail_sc_banner_msg_b: " in credit balance.",
    inv_detail_sc_apply_btn: "Apply to balance",
    inv_detail_sc_apply_notes: "Store Credit application",
    inv_detail_pay_form_amount: "AMOUNT",
    inv_detail_pay_form_method: "METHOD",
    inv_detail_pay_form_date: "DATE",
    inv_detail_pay_form_notes: "NOTES",
    inv_detail_pay_form_method_placeholder: "— Select —",
    inv_detail_pay_form_notes_placeholder: "Optional",
    inv_detail_pay_form_submit: "Save payment",
    inv_detail_cn_form_settlement: "SETTLEMENT TYPE",
    inv_detail_cn_form_refund: "Refund",
    inv_detail_cn_form_sc: "Store Credit",
    inv_detail_cn_form_hint_sc: "Will be credited to the customer's balance for future purchases.",
    inv_detail_cn_form_hint_refund: "Records the return of funds (cash, card, check, etc.).",
    inv_detail_cn_form_amount: "AMOUNT",
    inv_detail_cn_form_method: "REFUND METHOD (optional)",
    inv_detail_cn_form_method_none: "— (None) —",
    inv_detail_cn_form_reason: "REASON",
    inv_detail_cn_form_reason_placeholder: "E.g. Damage adjustment",
    inv_detail_cn_form_submit: "Issue CN",
    inv_detail_section_items: "Items (immutable snapshot)",
    inv_detail_section_payments: "Recorded payments ({n})",
    inv_detail_section_cns: "Credit notes ({n})",
    inv_detail_section_customer_notes: "Customer notes",
    inv_detail_meta_paid: "Paid:",
    inv_detail_meta_cancelled: "Cancelled:",
    inv_detail_no_payments: "No payments yet.",
    inv_detail_no_cns: "No credit notes.",
    inv_detail_payment_recorded_by: "recorded by {name}",
    inv_detail_summary_payments_received: "Payments received",
    inv_detail_summary_credit_notes: "Credit Notes",
    inv_detail_summary_balance: "BALANCE",

    // ─── Credit Notes Panel ───
    cn_panel_title: "Credit notes",
    cn_panel_subtitle: "{n} note{s} · reduce the source invoice balance.",
    cn_panel_load_err: "Could not load credit notes",
    cn_panel_pdf_err: "Could not generate the PDF",
    cn_panel_empty: "No credit notes issued yet.",
    cn_panel_col_invoice: "Invoice",
    cn_panel_col_client: "Customer",
    cn_panel_col_reason: "Reason",
    cn_panel_col_method: "Method",
    cn_panel_col_date: "Date",
    cn_panel_col_amount: "Amount",

    // ─── Work Orders Panel ───
    wo_panel_title: "Work Orders",
    wo_panel_subtitle: "{o} order{so} · {p} piece{sp} in production.",
    wo_panel_load_err: "Could not load Work Orders",
    wo_panel_open_err: "Could not open the Work Order",
    wo_panel_pdf_err: "Could not generate the PDF",
    wo_panel_search_placeholder: "Search by WO#, customer, source INV…",
    wo_panel_empty: "No Work Orders yet. Create one from an Invoice.",
    wo_panel_col_wo: "WO #",
    wo_panel_col_origin: "Source (Invoice)",
    wo_panel_col_client: "Customer",
    wo_panel_col_contact: "Contact",
    wo_panel_col_delivery: "Delivery",
    wo_panel_col_pieces: "Pieces",
    wo_panel_col_status: "Status",

    // ─── Customers Panel ───
    cust_panel_title: "Customers",
    cust_panel_subtitle: "Created automatically when saving estimates. We never duplicate.",
    cust_panel_new_btn: "+ New customer",
    cust_panel_search_placeholder: "Search by company, contact, phone, email…",
    cust_panel_load_err: "Could not load customers",
    cust_panel_empty: "No results.",
    cust_panel_none_selected: "Select a customer to view their profile.",
    cust_profile_load_err: "Could not load the profile",
    cust_profile_updated_ok: "Customer updated",
    cust_profile_save_err: "Save error",
    cust_profile_label: "PROFILE",
    cust_profile_edit_btn: "✎ Edit",
    cust_profile_contact: "Contact",
    cust_profile_phone: "Phone",
    cust_profile_email: "Email",
    cust_profile_store_credit: "Store Credit",
    cust_profile_notes: "Notes",
    cust_profile_notes_lower: "notes",
    cust_profile_history_title: "ESTIMATE HISTORY",
    cust_profile_history_empty: "No estimates yet.",
    cust_profile_files_title: "CLIENT FILES",
    cust_profile_files_empty: "No client files yet.",
    cust_profile_files_download: "Download",
    cust_profile_files_view: "View",
    file_preview_print: "Print",
    file_preview_download: "Download",
    file_preview_close: "Close",
    file_preview_load_err: "Could not load the preview.",
    cust_profile_files_download_err: "Could not download the file.",
    est_form_item_note_ph: "Product note (e.g. embroidered logo, thread color…)",
    task_product_note: "Product note",
    cust_profile_sc_history_title: "STORE CREDIT HISTORY",
    cust_profile_sc_applied: "APPLIED",
    cust_profile_sc_issued: "ISSUED",
    cust_new_title: "New customer",
    cust_new_company_required: "Company is required",
    cust_new_create_err: "Create error",
    cust_new_notes_placeholder: "Notes",
    cust_new_creating: "Saving…",
    cust_new_create_btn: "Create",

    // ─── Payments Section (Order modal) ───
    pay_amount_invalid: "Invalid amount",
    pay_ok: "Payment recorded",
    pay_delete_confirm: "Delete this payment?",
    pay_deleted_ok: "Payment deleted",
    pay_kpi_total: "TOTAL",
    pay_kpi_deposit_plus: "DEPOSIT + PAYMENTS",
    pay_kpi_pending: "PENDING",
    pay_none: "No additional payments yet",
    pay_field_amount: "Amount",
    pay_field_method: "Method",
    pay_field_note: "Note",
    pay_add_btn: "+ Record payment",

    // ─── Company Info Panel ───
    co_load_err: "Could not load settings",
    co_saved_ok: "Settings saved",
    co_save_err: "Save error",
    co_loading: "Loading settings…",
    co_back: "← Back",
    co_title: "Company Information",
    co_subtitle: "Data used in Estimates, Invoices and Credit Notes (header and footer).",
    co_section_general: "GENERAL DATA",
    co_field_name: "Company name",
    co_field_logo_url: "Logo URL (PNG/JPG)",
    co_field_website: "Website",
    co_field_email: "Company email (used in PDF and Resend)",
    co_field_phone: "Main phone",
    co_field_validity: "Estimate validity (days)",
    co_section_offices: "OFFICES",
    co_add_office: "+ Add office",
    co_office_key: "Key (identifier)",
    co_office_name: "Display name",
    co_office_address: "Address",
    co_office_phone: "Phone",
    co_office_email: "Email",
    co_office_remove: "Remove office",
    co_section_footers: "FOOTERS AND DOCUMENT NOTICES",
    co_field_prod_notice: "Production notice (printed on Estimates)",
    co_field_est_footer: "Estimate footer (one line per row)",
    co_field_inv_footer: "Invoice footer (one line per row)",
    co_field_inv_footer_placeholder: "Thank you for your purchase.\nOutstanding payments must be settled within the agreed terms.\nKeep this document for your records.",
    co_field_cn_footer: "Credit Note footer (one line per row)",
    co_field_cn_footer_placeholder: "This credit note adjusts the source invoice indicated above.\nKeep this document for your records.",
    co_field_pay_methods: "Accepted payment methods (comma separated)",
    co_field_whatsapp_tpl: "WhatsApp template",
    co_wa_placeholders_hint: "Available placeholders:",
    co_save_btn: "Save changes",

    // ─── GP 1.0 · Sprint D · Fase 2 (i18n coverage: Dashboard tabs +
    //     OrderDetailsModal actions + CustomProductEditor) ───
    action_mark_delivered: "✓ Mark as delivered",
    sku_optional_label: "SKU (optional)",
    custom_product_new_title: "New custom product",
    custom_product_edit_title: "Edit custom product",
    custom_product_subtitle: "Manual item — not from the catalog. Fields marked with * are required.",
    custom_product_item_label: "ITEM / CUSTOM",
    custom_product_description_label: "Description (printed on the PDF)",
    custom_product_artwork_label: "Artwork URL / customer artwork",
    field_decoration_section: "Decoration",
    field_method: "Method",
    field_taxable_option: "Taxable",
    field_exempt_option: "Exempt",
    custom_product_add_to_estimate: "Add to Estimate",
    custom_product_name_required: "Product name is required",
    custom_product_placeholder_name: "e.g., Premium black t-shirt",
    custom_product_placeholder_description: "e.g., 100% cotton t-shirt, size M, crew neck…",
    custom_product_placeholder_method: "DTF, Screen, Embroidery, Vinyl…",
    custom_product_placeholder_position: "e.g., Front Chest 4x4",
    custom_product_placeholder_colors: "e.g., Red, Black, White",

    // ─── GP 1.0 · Sprint E · Production Alerts Center ───
    alert_center_title: "Production alerts",
    alert_center_empty: "No pending alerts",
    alert_center_loading: "Loading alerts…",
    alert_invoice_missing_wo_title: "Invoice without Work Order",
    alert_time_just_now: "just now",
    alert_time_minutes: "{n} min ago",
    alert_time_hours: "{n} h ago",
    alert_time_days: "{n} d ago",
    alert_bell_tooltip: "Production alerts",

    // Bloque 4 — Partner Points commissions
    tab_commissions: "Commissions",
    comm_title_mine: "My commissions",
    comm_title_admin: "Commissions by Partner",
    comm_subtitle: "Recognized in the month the payment is completed · settled on days 1–5 of the following month",
    comm_rate_line: "Direct commission",
    comm_rate_suffix: "on paid sales, before taxes",
    comm_total: "Accumulated total",
    comm_period_total: "Period total",
    comm_empty: "No eligible paid sales yet.",
    comm_no_partners: "No Partner Points registered.",
    comm_from: "From",
    comm_to: "To",
    comm_filter: "Filter",
    comm_clear: "Clear",
    comm_pdf: "Download PDF",
    comm_pdf_error: "Could not generate the PDF",
    comm_col_invoice: "Invoice",
    comm_col_client: "Client",
    comm_col_issued: "Issued",
    comm_col_paid: "Paid",
    comm_col_base: "Base",
    comm_col_commission: "Commission",
    comm_status_pending: "Pending",
    comm_status_settled: "Settled",
    comm_status_paid: "Paid",
    comm_settle: "Settle month",
    comm_mark_paid: "Mark paid",
    comm_net: "Net",
    comm_adj_from: "Adjustment from",
    comm_settled_ok: "Month settled successfully",
    comm_paid_ok: "Settlement marked as paid",
    comm_settle_error: "The operation could not be completed",
    comm_error: "Could not load commissions",
    comm_select_partner: "Partner",
    comm_all_partners: "All Partners",
    comm_pay_title: "Record settlement payment",
    comm_pay_note: "Only records a payment already made outside GP. Cannot be modified afterwards.",
    comm_pay_date: "Actual payment date",
    comm_pay_method: "Method",
    comm_method_check: "Check",
    comm_check_number: "Check number",
    comm_zelle_ref: "Zelle reference (optional)",
    comm_pay_amount: "Amount paid",
    comm_pay_confirm: "Confirm payment",
    comm_cancel: "Cancel",
    comm_paid_via: "Paid via",
    comm_registered_by: "recorded by",
    comm_inv_cancelled: "Cancelled",
    comm_inv_credited: "Credited",

    // Bloque 5A — Partner Point transfer & delivery
    pd_title: "Partner Point Delivery",
    pd_step_sent: "Sent to Partner",
    pd_step_received: "Received at location",
    pd_step_delivered: "Delivered to customer",
    pd_mark_sent_btn: "Mark sent to Partner",
    pd_resend_btn: "Re-send (regenerates PIN)",
    pd_pin_note_admin: "The delivery PIN is only visible to the customer on their public invoice.",
    pd_confirm_received_btn: "Confirm reception",
    pd_pin_label: "Customer PIN",
    pd_deliver_btn: "Deliver order",
    pd_attempts_left: "Attempts left:",
    pd_pin_locked: "PIN locked — contact Rawen's",
    pd_delivered_msg: "Order delivered to customer",
    pd_ok: "Operation recorded",
    pd_error: "The operation could not be completed",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  const t = (key, ...args) => {
    const entry = dict[lang]?.[key] ?? dict.es?.[key] ?? key;
    if (typeof entry === "function") return entry(...args);
    // Named-param interpolation: t("key {n}", { n: 5 }) → replaces {n}
    if (typeof entry === "string" && args[0] && typeof args[0] === "object") {
      const params = args[0];
      return entry.replace(/\{(\w+)\}/g, (_, k) =>
        Object.prototype.hasOwnProperty.call(params, k) ? String(params[k]) : `{${k}}`
      );
    }
    return entry;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
